<template>
  <div class="card">
    <div class="card-body">
      <div class="row success">
        <div class="col-xl-8">
          <h5
            style="
              color: blue;
              margin-bottom: 30px;
              direction: ltr;
              text-align: left;
            "
          >
            <span style="margin-right: 30px; display: inline-block">{{
              $t("emploi.emplois")
            }}</span>

            <a-tooltip
              placement="right"
              v-if="selectedClasse"
              style="margin-left: 20px; display: inline-block"
            >
              <template slot="title">
                {{
                  selectedClassValidedSchedule
                    ? $t("emploi.hideEmploi", { name: selectedClassName })
                    : $t("emploi.validateEmploi", { name: selectedClassName })
                }}
              </template>
              <span>
                <a-button
                  :type="selectedClassValidedSchedule ? 'primary' : 'danger'"
                  @click="confirmScheduleValidation()"
                >
                  {{
                    selectedClassValidedSchedule
                      ? $t("bulletin.cancelValidation")
                      : $t("bulletin.validatedClassroom")
                  }}
                </a-button>
              </span>
            </a-tooltip>

            <a-tooltip
              placement="right"
              v-if="selectedClasse"
              style="margin-left: 20px; display: inline-block"
            >
              <template slot="title">
                {{ $t("emploi.hideTeacher") }}
              </template>
              <span style="display: flex; align-items: center; direction: ltr">
                <a-switch
                  :checked="selectedClassHideTeacher"
                  @change="toggleHideTeacher"
                  :loading="hideTeacherLoading"
                />
                <span style="margin-left: 8px; font-size: 12px; direction: ltr">
                  {{ $t("emploi.hideTeacher") }}
                </span>
              </span>
            </a-tooltip>
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>{{ $t("emploi.listeClasses") }}</label>
          <a-select
            id="selectClass"
            show-search
            :placeholder="$t('emploi.listeClasses')"
            option-filter-prop="children"
            :filter-option="filterOption"
            style="width: 150px; margin-left: 15px"
            @change="handleClassSelection"
          >
            <a-select-option
              v-for="classe in classes"
              :key="classe._id"
              :value="classe._id"
              >{{ classe.name }}</a-select-option
            >
          </a-select>
          <span
            v-if="currentWeekType"
            style="margin-left: 20px; font-weight: 500; color: #1890ff"
          >
            {{ $t("schedule.week") }}:
            {{
              currentWeekType === "A"
                ? $t("schedule.weekA")
                : $t("schedule.weekB")
            }}
          </span>
          <a-button
            v-if="smartScheduleAccess"
            class="mr-2 ml-2"
            style="float: right"
            type="primary"
            :loading="resetSchedulesLoading"
            :disabled="resetSchedulesLoading"
            @click="resetSchedules"
            >{{ $t("smartSchedule.unmigrate") }}</a-button
          >
          <!-- When countryIsTN is true, show dropdown -->
          <a-dropdown v-if="selectedClasse && countryIsTN" style="float: right">
            <template #overlay>
              <a-menu :selectedKeys="[]" @click="handlePDFLanguageSelection">
                <a-menu-item key="1">
                  {{ $t("language.ar") }}
                </a-menu-item>
                <a-menu-item key="2">
                  {{ $t("language.fr") }}
                </a-menu-item>
              </a-menu>
            </template>
            <a-button :loading="loadingPdf" :disabled="loadingPdf">
              <a-icon v-if="!loadingPdf" type="file-pdf" />{{
                $t("emploi.imprimerEmploi")
              }}
            </a-button>
          </a-dropdown>

          <!-- When countryIsTN is false, show normal button -->
          <a-button
            v-if="selectedClasse && !countryIsTN"
            style="float: right"
            :loading="loadingPdf"
            :disabled="loadingPdf"
            @click="generatePDFByCurrentLocale"
          >
            <a-icon v-if="!loadingPdf" type="file-pdf" />{{
              $t("emploi.imprimerEmploi")
            }}
          </a-button>
          <admin-pdf-schedule
            :trimester="selectedTrimester"
            class="mr-2"
            style="float: right"
          />
        </div>
      </div>

      <div class="mb-2">
        <a-row :gutter="16">
          <a-col :span="6">
            <span class="ml-2" v-if="selectedClasse">
              <stat
                :title="$t('emploi.totaleHeures')"
                :text="classHours.total"
                icon="clock-circle"
              />
            </span>
          </a-col>
          <a-col :span="6">
            <span class="ml-2" v-if="selectedClasse">
              <stat
                :title="$t('emploi.moyenneHeuresJour')"
                :text="classHours.moy"
                icon="clock-circle"
              />
            </span>
          </a-col>
          <a-col :span="6">
            <span class="ml-2" v-if="selectedClasse">
              <stat
                :title="$t('emploi.maximunHeuresJour')"
                :text="classHours.max"
                icon="clock-circle"
              />
            </span>
          </a-col>
          <a-col :span="6">
            <span class="ml-2" v-if="selectedClasse">
              <stat
                :title="$t('emploi.totaleTeachers')"
                :text="classHours.totalT"
                icon="read"
              />
            </span>
          </a-col>
        </a-row>
      </div>
      <a-alert
        v-if="updating"
        class="mb-2 mt-1"
        :message="$t('emploi.modeModif')"
        :description="$t('emploi.desc')"
        type="info"
        show-icon
      />
      <!-- START ADD DRAWER -->
      <a-drawer
        :title="$t('emploi.ajouterSeance') + ' : ' + selectedTime"
        :width="720"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
        class="session-drawer"
      >
        <!-- Session Info -->
        <div class="session-info mb-3">
          <a-descriptions size="small" :column="1" bordered>
            <a-descriptions-item :label="$t('emploi.selectedTime')">
              <a-time-picker
                :value="selectedTimeMoment"
                format="HH:mm"
                :allow-clear="false"
                :disabled-hours="() => disabledSessionHours"
                @change="handleDrawerTimeChange"
              />
            </a-descriptions-item>
            <a-descriptions-item :label="$t('emploi.selectedDay')">
              <a-icon type="calendar" class="text-primary mr-1" />
              {{ getDayName(selectedDay) }}
            </a-descriptions-item>
            <a-descriptions-item
              :label="$t('emploi.selectedClass')"
              v-if="selectedClassName"
            >
              <a-icon type="team" class="text-primary mr-1" />
              {{ selectedClassName }}
            </a-descriptions-item>
          </a-descriptions>
        </div>

        <a-form :form="form" layout="vertical">
          <!-- Teacher and Subject Row -->
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item :label="`${$t('emploi.enseignant')}`" required>
                <a-select
                  v-decorator="[
                    'teacher',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('emploi.choisirEnseignant'),
                        },
                      ],
                      validateTrigger: ['change', 'blur'],
                    },
                  ]"
                  :placeholder="$t('emploi.choisirEnseignant')"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-opt-group :label="$t('emploi.disponible')">
                    <a-select-option
                      v-for="teacher in filtredTeachers.disponible"
                      :key="teacher._id"
                      :value="teacher._id"
                    >
                      <a-icon type="user" class="text-success mr-1" />
                      {{
                        teacher.employee.firstName +
                        " " +
                        teacher.employee.lastName
                      }}
                    </a-select-option>
                  </a-select-opt-group>
                  <a-select-opt-group :label="$t('emploi.indisponible')">
                    <a-select-option
                      :disabled="true"
                      v-for="teacher in filtredTeachers.indisponible"
                      :key="teacher._id"
                      :value="teacher._id"
                    >
                      <a-icon type="user" class="text-muted mr-1" />
                      {{
                        teacher.employee.firstName +
                        " " +
                        teacher.employee.lastName
                      }}
                    </a-select-option>
                  </a-select-opt-group>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="`${$t('emploi.matiere')}`" required>
                <a-select
                  v-decorator="[
                    'subject',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('emploi.choisirMatiere'),
                        },
                      ],
                      validateTrigger: ['change', 'blur'],
                    },
                  ]"
                  :placeholder="$t('emploi.choisirMatiere')"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="handleSubjectSelectChange"
                >
                  <a-select-option
                    v-for="item in allSubjects"
                    :key="item._id"
                    :value="item._id"
                  >
                    <a-icon
                      :type="item.isModule ? 'book' : 'read'"
                      :class="
                        item.isModule
                          ? 'text-primary mr-1'
                          : 'text-secondary mr-1'
                      "
                    />
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- Room and Group Row -->
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item :label="$t('emploi.salle')">
                <a-select
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-decorator="[
                    'room',
                    {
                      rules: [
                        {
                          required: false,
                          message: $t('emploi.choisirSalle'),
                        },
                      ],
                    },
                  ]"
                  :placeholder="$t('emploi.choisirSalle')"
                  allowClear
                >
                  <a-select-opt-group :label="$t('emploi.disponible')">
                    <a-select-option
                      v-for="room in filtredRooms.disponible"
                      :key="room._id"
                      :value="room._id"
                    >
                      <a-icon type="home" class="text-success mr-1" />
                      {{ room.name }}
                    </a-select-option>
                  </a-select-opt-group>
                  <a-select-opt-group :label="$t('emploi.indisponible')">
                    <a-select-option
                      :disabled="true"
                      v-for="room in filtredRooms.indisponible"
                      :key="room._id"
                      :value="room._id"
                    >
                      <a-icon type="home" class="text-muted mr-1" />
                      {{ room.name }}
                    </a-select-option>
                  </a-select-opt-group>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('emploi.group')">
                <a-select
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-decorator="['group']"
                  :placeholder="$t('emploi.groupOption')"
                  allowClear
                >
                  <a-select-option :value="null">
                    <a-icon type="team" class="mr-1" />
                    {{ $t("emploi.fullClass") }}
                  </a-select-option>
                  <a-select-option
                    v-for="g in groups"
                    :key="g._id"
                    :value="g._id"
                  >
                    <a-icon type="usergroup-add" class="mr-1" />
                    {{ g.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- Week and Duration Row -->
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item :label="$t('emploi.week')">
                <a-select
                  v-decorator="['week']"
                  :placeholder="$t('emploi.weekOption')"
                  allowClear
                >
                  <a-select-option :value="null">
                    {{ $t("emploi.weekBoth") }}
                  </a-select-option>
                  <a-select-option value="A">
                    <a-tag color="blue" size="small" class="mr-1">A</a-tag>
                    {{ $t("emploi.weekA") }}
                  </a-select-option>
                  <a-select-option value="B">
                    <a-tag color="green" size="small" class="mr-1">B</a-tag>
                    {{ $t("emploi.weekB") }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="`${$t('emploi.duree')}`" required>
                <a-select
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-decorator="[
                    'duration',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('emploi.choisirDuree'),
                        },
                      ],
                      validateTrigger: ['change', 'blur'],
                    },
                  ]"
                  :placeholder="$t('emploi.choisirDuree')"
                >
                  <a-select-option
                    v-for="duration in durationOptions"
                    :key="duration.value"
                    :value="duration.value"
                  >
                    {{ duration.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- Session Name Row -->
          <a-row>
            <a-col :span="24">
              <a-form-item :label="`${$t('emploi.name')}`" required>
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('emploi.choisirName'),
                        },
                      ],
                      validateTrigger: ['change', 'blur'],
                    },
                  ]"
                  :placeholder="$t('emploi.choisirName')"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <!-- Error Alert -->
        <a-alert
          v-if="submitError"
          :message="submitError.message"
          :description="submitError.description"
          type="error"
          show-icon
          closable
          class="mb-3"
        />

        <!-- Action Buttons -->
        <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="onClose">
            {{ $t("action.annuler") }}
          </a-button>
          <a-button
            type="primary"
            @click="handleSubmit"
            :loading="loadingAddBtn"
            :disabled="loadingAddBtn"
          >
            {{ $t("action.ajouter") }}
          </a-button>
        </div>
      </a-drawer>
      <!-- END ADD DRAWER -->
    </div>
    <div style="position: relative">
      <FullCalendar
        ref="calendar"
        class="demo-app-calendar"
        :options="calendarOptions"
        style="margin-left: 10px; margin-right: 10px"
      />
      <div
        v-if="calendarLoading"
        class="calendar-loading-overlay"
        style="
          position: absolute;
          top: 0;
          left: 10px;
          right: 10px;
          bottom: 0;
          background-color: rgba(255, 255, 255, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        "
      >
        <a-spin size="large">
          <template #indicator>
            <a-icon type="loading" style="font-size: 24px" spin />
          </template>
        </a-spin>
      </div>
    </div>
    <!-- START UPDATE DRAWER -->
    <a-drawer
      :title="$t('emploi.modifierSeance') + ' : ' + selectedTime"
      :width="720"
      :visible="updateVisible"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
      class="session-drawer"
    >
      <!-- Session Info -->
      <div class="session-info mb-3">
        <a-descriptions size="small" :column="1" bordered>
          <a-descriptions-item :label="$t('emploi.selectedTime')">
            <a-time-picker
              :value="selectedTimeMoment"
              format="HH:mm"
              :allow-clear="false"
              :disabled-hours="() => disabledSessionHours"
              @change="handleDrawerTimeChange"
            />
          </a-descriptions-item>
          <a-descriptions-item :label="$t('emploi.selectedDay')">
            <a-icon type="calendar" class="text-primary mr-1" />
            {{ getDayName(selectedDay) }}
          </a-descriptions-item>
          <a-descriptions-item
            :label="$t('emploi.selectedClass')"
            v-if="selectedClassName"
          >
            <a-icon type="team" class="text-primary mr-1" />
            {{ selectedClassName }}
          </a-descriptions-item>
        </a-descriptions>
      </div>

      <a-form :form="form" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.enseignant')}`">
              <a-select
                v-decorator="[
                  'teacher',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('emploi.choisirEnseignant'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirEnseignant')"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-if="fullTeacherName === 'Teacher is hidden'"
                  :value="null"
                  :disabled="true"
                >
                  <a-icon type="user" class="text-muted mr-1" />
                  Teacher is hidden
                </a-select-option>
                <a-select-opt-group :label="$t('emploi.disponible')">
                  <a-select-option
                    v-for="teacher in filtredTeachers.disponible"
                    :key="teacher._id"
                    :value="teacher._id"
                  >
                    <a-icon type="user" class="text-success mr-1" />
                    {{
                      teacher.employee.firstName +
                      " " +
                      teacher.employee.lastName
                    }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('emploi.indisponible')">
                  <a-select-option
                    :disabled="true"
                    v-for="teacher in filtredTeachers.indisponible"
                    :key="teacher._id"
                    :value="teacher._id"
                  >
                    <a-icon type="user" class="text-muted mr-1" />
                    {{
                      teacher.employee.firstName +
                      " " +
                      teacher.employee.lastName
                    }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.matiere')}`" required>
              <a-select
                v-decorator="[
                  'subject',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirMatiere'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirMatiere')"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="handleSubjectSelectChange"
              >
                <a-select-option
                  v-for="item in allSubjects"
                  :key="item._id"
                  :value="item._id"
                >
                  <a-icon
                    :type="item.isModule ? 'book' : 'read'"
                    :class="
                      item.isModule
                        ? 'text-primary mr-1'
                        : 'text-secondary mr-1'
                    "
                  />
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('emploi.salle')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="[
                  'room',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('emploi.choisirSalle'),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('emploi.choisirSalle')"
                allowClear
              >
                <a-select-opt-group :label="$t('emploi.disponible')">
                  <a-select-option
                    v-for="room in filtredRooms.disponible"
                    :key="room._id"
                    :value="room._id"
                  >
                    <a-icon type="home" class="text-success mr-1" />
                    {{ room.name }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('emploi.indisponible')">
                  <a-select-option
                    :disabled="true"
                    v-for="room in filtredRooms.indisponible"
                    :key="room._id"
                    :value="room._id"
                  >
                    <a-icon type="home" class="text-muted mr-1" />
                    {{ room.name }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('emploi.group')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['group']"
                :placeholder="$t('emploi.groupOption')"
                allowClear
              >
                <a-select-option :value="null">
                  <a-icon type="team" class="mr-1" />
                  {{ $t("emploi.fullClass") }}
                </a-select-option>
                <a-select-option
                  v-for="g in groups"
                  :key="g._id"
                  :value="g._id"
                >
                  <a-icon type="usergroup-add" class="mr-1" />
                  {{ g.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('emploi.week')">
              <a-select
                v-decorator="['week']"
                :placeholder="$t('emploi.weekOption')"
                allowClear
              >
                <a-select-option :value="null">
                  {{ $t("emploi.weekBoth") }}
                </a-select-option>
                <a-select-option value="A">
                  <a-tag color="blue" size="small" class="mr-1">A</a-tag>
                  {{ $t("emploi.weekA") }}
                </a-select-option>
                <a-select-option value="B">
                  <a-tag color="green" size="small" class="mr-1">B</a-tag>
                  {{ $t("emploi.weekB") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.duree')} `" required>
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="[
                  'duration',
                  {
                    rules: [
                      { required: true, message: $t('emploi.choisirDuree') },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirDuree')"
              >
                <a-select-option
                  v-for="duration in durationOptions"
                  :key="duration.value"
                  :value="duration.value"
                  >{{ duration.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.name')} `" required>
              <a-input
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirName'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirName')"
              >
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- Canceled Session Alert -->
      <a-alert
        v-if="selectedSchedule && selectedSchedule.canceled"
        :message="$t('emploi.sessionCanceled')"
        :description="selectedSchedule.cancellationReason"
        type="warning"
        show-icon
        class="mb-3"
      >
        <template slot="description">
          <div>
            <strong>{{ $t("emploi.cancellationReason") }}:</strong>
            {{ selectedSchedule.cancellationReason }}
            <br />
          </div>
        </template>
      </a-alert>

      <!-- Error Alert -->
      <a-alert
        v-if="submitError"
        :message="submitError.message"
        :description="submitError.description"
        type="error"
        show-icon
        closable
        class="mb-3"
      />

      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button
          :style="{ marginRight: '8px' }"
          type="danger"
          @click="deleteSchedule"
        >
          {{ $t("action.supprimer") }}
        </a-button>
        <a-button
          v-if="selectedSchedule && !selectedSchedule.canceled"
          :style="{ marginRight: '8px' }"
          type="warning"
          @click="showCancelModal"
        >
          {{ $t("emploi.cancelSession") }}
        </a-button>
        <a-button
          v-if="selectedSchedule && selectedSchedule.canceled"
          :style="{ marginRight: '8px' }"
          type="success"
          @click="restoreSession"
        >
          {{ $t("emploi.restoreSession") }}
        </a-button>
        <a-button :style="{ marginRight: '8px' }" @click="onClose">{{
          $t("action.annuler")
        }}</a-button>
        <a-popconfirm
          v-if="selectedSchedule && !selectedSchedule.canceled"
          :title="$t('emploi.updateSessionQuestion')"
          :ok-text="$t('emploi.updateAllSimilar')"
          :cancel-text="$t('emploi.updateOnlyThis')"
          @confirm="openBulkUpdateCalendar"
          @cancel="performSingleUpdate"
        >
          <a-button
            type="primary"
            :loading="updateLoading"
            :disabled="updateLoading"
            @click="handleUpdate"
          >
            {{ $t("action.modifier") }}
          </a-button>
        </a-popconfirm>
      </div>
    </a-drawer>
    <!-- END UPDATE DRAWER -->

    <!-- CANCEL SESSION MODAL -->
    <a-modal
      :title="$t('emploi.cancelSession')"
      :visible="cancelModalVisible"
      @ok="handleCancelSession"
      @cancel="cancelModalVisible = false"
      :confirmLoading="cancelLoading"
      :okText="$t('emploi.confirmCancel')"
      :cancelText="$t('action.annuler')"
      okType="danger"
    >
      <div class="cancel-session-modal">
        <a-alert
          :message="$t('emploi.cancelSessionWarning')"
          :description="$t('emploi.cancelSessionDescription')"
          type="warning"
          show-icon
          class="mb-3"
        />

        <a-form-item :label="$t('emploi.cancellationReason')" required>
          <a-textarea
            v-model="cancellationReason"
            :placeholder="$t('emploi.enterCancellationReason')"
            :rows="4"
            :maxLength="500"
            show-count
          />
        </a-form-item>

        <a-form-item :label="$t('emploi.cancelUntil')" required>
          <a-date-picker
            v-model="canceledUntil"
            :placeholder="$t('emploi.selectCancelUntilDate')"
            style="width: 100%"
            :disabled-date="disabledDate"
            :show-time="false"
            format="YYYY-MM-DD"
          />
          <div class="text-muted mt-1">
            <small>{{ $t("emploi.cancelUntilDescription") }}</small>
          </div>
        </a-form-item>

        <div v-if="selectedSchedule" class="session-info">
          <a-descriptions size="small" :column="1" bordered>
            <a-descriptions-item :label="$t('emploi.sessionDetails')">
              <div>
                <strong>{{
                  selectedSchedule.name ||
                  (selectedSchedule.subject
                    ? selectedSchedule.subject.name
                    : "")
                }}</strong>
                <br />
                <small class="text-muted">
                  {{
                    getDayName(
                      selectedSchedule.day instanceof Date
                        ? selectedSchedule.day.getDay() - 1
                        : selectedSchedule.day
                    )
                  }}
                  -
                  {{ selectedSchedule.time }}
                  <span
                    v-if="selectedSchedule.room && selectedSchedule.room.name"
                  >
                    - {{ selectedSchedule.room.name }}
                  </span>
                </small>
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </a-modal>
    <!-- END CANCEL SESSION MODAL -->

    <!-- CALENDAR DATE PICKER MODAL -->
    <a-modal
      :title="$t('emploi.selectEndDate')"
      :visible="showCalendarModal"
      @ok="handleCalendarConfirm"
      @cancel="cancelPendingUpdate"
      :okText="$t('action.confirmer')"
      :cancelText="$t('action.annuler')"
      :confirmLoading="updateLoading"
      okType="primary"
      width="450px"
    >
      <div class="calendar-picker-modal">
        <div class="calendar-header">
          <p>{{ $t("emploi.selectEndDateDescription") }}</p>
        </div>

        <div class="duration-options">
          <a-radio-group v-model="durationOption" class="mb-3">
            <a-radio value="until-end-year" class="duration-radio">
              <a-icon type="calendar" class="mr-2" />
              {{ $t("emploi.untilEndOfYear") }}
            </a-radio>

            <a-radio value="whole-year" class="duration-radio">
              <a-icon type="schedule" class="mr-2" />
              {{ $t("emploi.wholeSchoolYear") }}
            </a-radio>

            <a-radio value="custom" class="duration-radio">
              <a-icon type="clock-circle" class="mr-2" />
              {{ $t("emploi.customDuration") }}
            </a-radio>
          </a-radio-group>
        </div>

        <div v-if="durationOption === 'custom'" class="calendar-container">
          <a-date-picker
            v-model="customEndDate"
            :placeholder="$t('emploi.selectEndDate')"
            :disabled-date="disabledDate"
            @change="onDateSelect"
            style="width: 100%"
          />
        </div>

        <div
          v-if="customEndDate && durationOption === 'custom'"
          class="selected-date-preview"
        >
          <a-icon type="calendar" />
          <span
            >{{ $t("emploi.selectedDate") }}: {{ formattedCustomEndDate }}</span
          >
        </div>
      </div>
    </a-modal>
    <!-- END CALENDAR MODAL -->

    <!-- DRAG / RESIZE UPDATE CHOICE MODAL -->
    <a-modal
      :title="$t('emploi.updateSessionQuestion')"
      :visible="dragUpdateModalVisible"
      :maskClosable="false"
      wrapClassName="update-session-modal"
      @cancel="cancelPendingUpdate"
    >
      <p>{{ $t("emploi.updateSessionOptions") }}</p>
      <template slot="footer">
        <a-button @click="cancelPendingUpdate">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button :loading="updateLoading" @click="confirmDragUpdateSingle">
          {{ $t("emploi.updateOnlyThis") }}
        </a-button>
        <a-button type="primary" @click="confirmDragUpdateAll">
          {{ $t("emploi.updateAllSimilar") }}
        </a-button>
      </template>
    </a-modal>
    <!-- END DRAG / RESIZE UPDATE CHOICE MODAL -->

    <!-- DELETE SESSION CONFIRMATION MODAL -->
    <a-modal
      :title="$t('emploi.deleteSession')"
      :visible="deleteModalVisible"
      @ok="handleDeleteSingle"
      @cancel="deleteModalVisible = false"
      :okText="$t('emploi.deleteOnlyThis')"
      :cancelText="$t('action.annuler')"
      okType="danger"
      class="delete-session-modal"
    >
      <div class="delete-session-content">
        <p style="margin-bottom: 16px">
          {{ $t("emploi.deleteSessionQuestion") }}<br />
          <strong
            >{{ deleteSessionInfo.sessionName }} -
            {{ deleteSessionInfo.sessionDate }}
            {{ deleteSessionInfo.sessionTime }}</strong
          ><br />
          <span style="color: #666">{{ deleteSessionInfo.classroomName }}</span>
        </p>
        <p style="margin-bottom: 16px">
          {{ $t("emploi.deleteSessionOptions") }}
        </p>
      </div>
      <template slot="footer">
        <a-button @click="deleteModalVisible = false">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="danger"
          class="delete-action-btn"
          @click="handleDeleteRecurring"
        >
          {{ $t("emploi.deleteRecurring") }}
        </a-button>
        <a-button
          type="danger"
          class="delete-action-btn"
          @click="handleDeleteSingle"
        >
          {{ $t("emploi.deleteOnlyThis") }}
        </a-button>
      </template>
    </a-modal>
    <!-- END DELETE SESSION CONFIRMATION MODAL -->

    <!-- ADD SESSION MODAL -->
    <a-modal
      :title="$t('emploi.addSession')"
      :width="600"
      :visible="addSessionModalVisible"
      :body-style="{ paddingBottom: '80px' }"
      @cancel="closeAddSessionModal"
      class="add-session-modal"
    >
      <a-form
        :form="addSessionForm"
        layout="vertical"
        @submit="handleAddSessionSubmit"
      >
        <!-- Teacher and Subject Row -->
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.enseignant')}`" required>
              <a-select
                v-decorator="[
                  'teacher',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirEnseignant'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirEnseignant')"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-opt-group :label="$t('emploi.disponible')">
                  <a-select-option
                    v-for="teacher in filtredTeachers.disponible"
                    :key="teacher._id"
                    :value="teacher._id"
                  >
                    <a-icon type="user" class="text-success mr-1" />
                    {{
                      teacher.employee.firstName +
                      " " +
                      teacher.employee.lastName
                    }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('emploi.indisponible')">
                  <a-select-option
                    :disabled="true"
                    v-for="teacher in filtredTeachers.indisponible"
                    :key="teacher._id"
                    :value="teacher._id"
                  >
                    <a-icon type="user" class="text-muted mr-1" />
                    {{
                      teacher.employee.firstName +
                      " " +
                      teacher.employee.lastName
                    }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.matiere')}`" required>
              <a-select
                v-decorator="[
                  'subject',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirMatiere'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirMatiere')"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                @change="handleAddSessionSubjectSelectChange"
              >
                <a-select-option
                  v-for="item in allSubjects"
                  :key="item._id"
                  :value="item._id"
                >
                  <a-icon
                    :type="item.isModule ? 'book' : 'read'"
                    :class="
                      item.isModule
                        ? 'text-primary mr-1'
                        : 'text-secondary mr-1'
                    "
                  />
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- Room and Group Row -->
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('emploi.salle')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="[
                  'room',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('emploi.choisirSalle'),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('emploi.choisirSalle')"
                allowClear
              >
                <a-select-opt-group :label="$t('emploi.disponible')">
                  <a-select-option
                    v-for="room in filtredRooms.disponible"
                    :key="room._id"
                    :value="room._id"
                  >
                    <a-icon type="home" class="text-success mr-1" />
                    {{ room.name }}
                  </a-select-option>
                </a-select-opt-group>
                <a-select-opt-group :label="$t('emploi.indisponible')">
                  <a-select-option
                    :disabled="true"
                    v-for="room in filtredRooms.indisponible"
                    :key="room._id"
                    :value="room._id"
                  >
                    <a-icon type="home" class="text-muted mr-1" />
                    {{ room.name }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('emploi.group')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="['group']"
                :placeholder="$t('emploi.groupOption')"
                allowClear
              >
                <a-select-option :value="null">
                  <a-icon type="team" class="mr-1" />
                  {{ $t("emploi.fullClass") }}
                </a-select-option>
                <a-select-option
                  v-for="g in groups"
                  :key="g._id"
                  :value="g._id"
                >
                  <a-icon type="usergroup-add" class="mr-1" />
                  {{ g.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- Week and Duration Row -->
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('emploi.week')">
              <a-select
                v-decorator="['week']"
                :placeholder="$t('emploi.weekOption')"
                allowClear
              >
                <a-select-option :value="null">
                  {{ $t("emploi.weekBoth") }}
                </a-select-option>
                <a-select-option value="A">
                  <a-tag color="blue" size="small" class="mr-1">A</a-tag>
                  {{ $t("emploi.weekA") }}
                </a-select-option>
                <a-select-option value="B">
                  <a-tag color="green" size="small" class="mr-1">B</a-tag>
                  {{ $t("emploi.weekB") }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`${$t('emploi.duree')}`" required>
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="[
                  'duration',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirDuree'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirDuree')"
              >
                <a-select-option
                  v-for="duration in [
                    { name: '30min', value: 2 },
                    { name: '45min', value: 3 },
                    { name: '1h', value: 4 },
                    { name: '1h15', value: 5 },
                    { name: '1h30', value: 6 },
                    { name: '1h45', value: 7 },
                    { name: '2h', value: 8 },
                    { name: '2h15', value: 9 },
                    { name: '2h30', value: 10 },
                  ]"
                  :key="duration.value"
                  :value="duration.value"
                >
                  {{ duration.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- Day and Time Row -->
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :label="$t('emploi.day')" required>
              <a-select
                v-decorator="[
                  'day',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.pleaseSelectDay'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.selectDay')"
                @change="handleDayChange"
              >
                <a-select-option
                  v-for="(day, index) in weekDays"
                  :key="index"
                  :value="index"
                >
                  {{ day }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('emploi.temps')" required>
              <a-time-picker
                v-decorator="[
                  'time',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirTemps'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirTemps')"
                format="HH:mm"
                :disabled-hours="() => disabledSessionHours"
                style="width: 100%"
                @change="handleTimeChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="`${$t('emploi.name')}`" required>
              <a-input
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirName'),
                      },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
                :placeholder="$t('emploi.choisirName')"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-alert
          v-if="addSessionError"
          :message="addSessionError.message"
          :description="addSessionError.description"
          type="error"
          show-icon
          class="mb-3"
        />
      </a-form>

      <template slot="footer">
        <a-button @click="closeAddSessionModal">
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          :loading="addSessionLoading"
          @click="handleAddSessionSubmit"
        >
          {{ $t("emploi.addSession") }}
        </a-button>
      </template>
    </a-modal>
    <!-- END ADD SESSION MODAL -->
  </div>
</template>
<script>
/*eslint-disable */

import apiClient from "@/services/axios";
import { mapState } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import allLocales from "@fullcalendar/core/locales-all";
import stat from "./component/stat";
import adminPdfSchedule from "./component/adminPdfSchedule";
import JsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import moment from "moment";
import { getFullSchoolName } from "@/utilities/buildingTypeLabel";
import { showApiError } from "@/utilities/showApiError";
(function (jsPDFAPI) {
  // 1) ZWJ + special-character helper
  const zwj = "\u200D";
  const specials = ["\u06A8", "\u0651"]; // ڨ (GAF), SHADDA

  function fixArabicLigatures(s) {
    let out = "";
    for (let i = 0; i < s.length; i++) {
      out += s[i];
      if (
        s[i + 1] &&
        (specials.includes(s[i]) || specials.includes(s[i + 1]))
      ) {
        out += zwj;
      }
    }
    return out;
  }

  // 2) Shaping wrapper
  function shapeIfArabic(txt) {
    // Only shape if there's at least one Arabic code-point
    if (!/[\u0600-\u06FF]/.test(txt)) {
      return txt;
    }
    // Make sure the plugin is there
    if (typeof jsPDFAPI.processArabic !== "function") {
      console.error("Arabic plugin missing! Include modules/arabic.js first.");
      return txt;
    }
    // Reverse for RTL + shape
    return jsPDFAPI.processArabic(fixArabicLigatures(txt), true);
  }

  // 3) Register your shaper on every call to doc.text()
  jsPDFAPI.events.push([
    "preProcessText",
    function (originalText /*, renderOptions */) {
      // return the (possibly transformed) string
      return shapeIfArabic(originalText);
    },
  ]);
})(JsPDF.API);

export default {
  components: {
    FullCalendar,
    adminPdfSchedule,
    stat: stat,
  },
  async created() {
    try {
      // Load classes and teachers/rooms in parallel
      const [classesRes, teachersRes, roomsRes] = await Promise.all([
        apiClient.post("/classrooms/filter", {
          query: { status: "active" },
          aggregation: {
            $project: {
              _id: 1,
              name: 1,
              teachers: 1,
              level: 1,
              schedule: 1,
              hideTeacher: 1,
            },
          },
        }),
        apiClient.post("/teachers/filter", { query: { status: "active" } }),
        apiClient.post("/rooms/filter", { query: {} }),
      ]);

      this.classes = classesRes.data;
      this.teachers = teachersRes.data;
      this.rooms = roomsRes.data;

      // Build validation schedule map
      classesRes.data.forEach((classRoom) => {
        this.isValidatedSchedule[classRoom._id] = classRoom.schedule;
      });

      // Initialize hideTeacher value if a class is already selected
      if (this.selectedClasse) {
        const selectedClass = this.classes.find(
          (item) => item._id === this.selectedClasse
        );
        if (selectedClass) {
          this.selectedClassHideTeacher = selectedClass.hideTeacher || false;
        }
      }

      // Get building info
      const building = this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
      this.smartScheduleAccess =
        building.pack.access.edManager["smartSchedule"];

      // Initialize selected week to current week (Monday)
      const currentDate = new Date();
      const mondayDate = new Date(currentDate);
      mondayDate.setDate(currentDate.getDate() - currentDate.getDay() + 1);
      mondayDate.setHours(0, 0, 0, 0);
      this.$set(this, "selectedWeekStart", mondayDate);
    } catch (error) {
      this.$message.error(this.$t("error.error"));
    }
  },
  data() {
    return {

      smartScheduleAccess: false,
      isValidatedSchedule: {},
      selectedClassValidedSchedule: false,
      selectedClassHideTeacher: false,
      hideTeacherLoading: false,
      justUpdatedHideTeacher: false,
      resetSchedulesLoading: false,
      selectedSchedule: null,
      filtredTeachers: {},
      filtredRooms: {},
      subjects: [],
      modules: [],
      includedSubjects: [],
      teachers: [],
      rooms: [],
      groups: [],
      selectedClasse: null,
      selectedLevel: null,
      data: [],
      loadingPdf: false,
      classes: [],
      form: this.$form.createForm(this),
      visible: false,
      updateVisible: false,
      selectedDay: null,
      selectedTime: null,
      loading: false,
      calendarLoading: false,
      selectedTrimester: 0,
      submitError: null,
      loadingAddBtn: false,
      selectedClassName: null,
      updating: false,
      cancelModalVisible: false,
      cancellationReason: "",
      canceledUntil: null,
      cancelLoading: false,
      updateLoading: false,
      customEndDate: null,
      showCalendarModal: false,
      pendingUpdateData: null,
      pendingRevert: null,
      dragUpdateModalVisible: false,
      durationOption: "until-end-year",
      deleteModalVisible: false,
      deleteSessionInfo: {
        sessionName: "",
        sessionDate: "",
        sessionTime: "",
        classroomName: "",
      },
      selectedWeekStart: null, // Track the currently selected week start date
      addSessionModalVisible: false,
      addSessionForm: this.$form.createForm(this),
      addSessionLoading: false,
      addSessionError: null,
      weekDays: [
        this.$t("days.monday"),
        this.$t("days.tuesday"),
        this.$t("days.wednesday"),
        this.$t("days.thursday"),
        this.$t("days.friday"),
        this.$t("days.saturday"),
      ],
      fullTeacherName: "",
    };
  },
  methods: {
    // Helper methods for enhanced UI
    handleClassSelection(val) {
      this.selectedClasse = val;
      this.calendarLoading = true;
      this.handleClassChange(val);
      this.updateAddSessionButton();
    },
    handlePDFLanguageSelection(val) {
      if (val.key == "1") this.generatePDF("ar");
      else this.generatePDF("fr");
    },
    generatePDFByCurrentLocale() {
      // Generate PDF based on current i18n locale
      const currentLocale = this.$i18n.locale;
      // Map i18n locale to PDF language
      // ar-AR -> ar, en-US -> en, sw-KE -> sw, fr-FR -> fr (default)
      let pdfLang = "fr"; // default to French
      if (currentLocale === "ar-AR") {
        pdfLang = "ar";
      } else if (currentLocale === "en-US") {
        pdfLang = "en";
      } else if (currentLocale === "sw-KE") {
        pdfLang = "sw";
      } else if (currentLocale === "fr-FR") {
        pdfLang = "fr";
      }
      this.generatePDF(pdfLang);
    },
    getDayName(dayIndex) {
      const days = [
        this.$t("days.monday"),
        this.$t("days.tuesday"),
        this.$t("days.wednesday"),
        this.$t("days.thursday"),
        this.$t("days.friday"),
        this.$t("days.saturday"),
      ];
      return days[dayIndex] || "-";
    },
    validateTimetableLimits(startTime, duration, day) {
      // Calculate end time
      const endTime = this.endTime(startTime, duration);

      // Convert times to minutes for comparison
      const convertTimeToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };

      const sessionEndMinutes = convertTimeToMinutes(endTime);
      const timetableEndMinutes = convertTimeToMinutes("18:00");

      if (sessionEndMinutes > timetableEndMinutes) {
        this.$message.error(
          this.$t("schedule.timetableExceeded", {
            endTime: endTime,
            timetableEnd: "18:00",
            day: this.getDayName(day),
          })
        );
        return false;
      }

      return true;
    },

    getCalendarEvents(_info, success) {
      const toTwo = (n) => (n < 10 ? `0${n}` : `${n}`);
      const events = [];

      (this.data || []).forEach((sched) => {
        const event = this.createEventFromSchedule(sched, _info, toTwo);
        if (event) {
          events.push(event);
        }
      });

      // Turn off calendar loading when events are loaded
      this.$nextTick(() => {
        this.calendarLoading = false;
      });

      success(events);
    },
    createEventFromSchedule(sched, _info, toTwo) {
      if (!sched || typeof sched !== "object" || !sched.time) {
        return null;
      }

      const [h, m] = sched.time.split(":");
      const startTime = `${toTwo(Number(h))}:${toTwo(Number(m))}:00`;
      const [eh, em] = (
        sched.ends || this.endTime(sched.time, sched.duration)
      ).split(":");
      const endTime = `${toTwo(Number(eh))}:${toTwo(Number(em))}:00`;

      // Check if session should be considered canceled based on current date
      const isCurrentlyCanceled = this.isSessionCurrentlyCanceled(sched);

      const title = this.buildEventTitle(sched, isCurrentlyCanceled);
      const className = this.getEventClasses(sched, this.data);

      const baseEvent = {
        title,
        start: null,
        end: null,
        extendedProps: { record: sched },
        backgroundColor: isCurrentlyCanceled ? "#f8d7da" : "#f8f9fa",
        borderColor: isCurrentlyCanceled ? "#dc3545" : "#dee2e6",
        textColor: isCurrentlyCanceled ? "#721c24" : "#495057",
        className: isCurrentlyCanceled
          ? `${className} canceled-event`
          : className,
      };

      // Handle specific date format
      if (sched.day instanceof Date || typeof sched.day === "string") {
        const sessionDate = new Date(sched.day);
        const eventDate = this.formatDate(sessionDate);
        return {
          ...baseEvent,
          id: sched._id,
          start: `${eventDate}T${startTime}`,
          end: `${eventDate}T${endTime}`,
        };
      }

      // Handle biweekly events
      if (sched.week === "A" || sched.week === "B") {
        return this.createBiweeklyEvents(
          sched,
          _info,
          startTime,
          endTime,
          baseEvent
        );
      }

      // Regular weekly recurring event
      return {
        ...baseEvent,
        id: sched._id,
        daysOfWeek: [Number(sched.day) + 1],
        startTime,
        endTime,
      };
    },
    isSessionCurrentlyCanceled(sched) {
      if (!sched || typeof sched !== "object") {
        return false;
      }
      return sched.canceled === true;
    },
    buildEventTitle(sched, isCurrentlyCanceled = null) {
      if (!sched || typeof sched !== "object") {
        return "";
      }

      let title = sched.name || (sched.subject ? sched.subject.name : "");
      const duration = Number(sched.duration) || 60; // Default to 60 minutes (1 hour) if not specified
      const isShortSession = duration < 60; // Less than 1 hour
      const isVeryShortSession = duration < 30; // Less than 30 minutes
      const titleLength = title.length;

      // Dynamic title truncation based on duration and title length
      if (isVeryShortSession && titleLength > 15) {
        title = title.substring(0, 12) + "...";
      } else if (isShortSession && titleLength > 25) {
        title = title.substring(0, 22) + "...";
      } else if (titleLength > 35) {
        title = title.substring(0, 32) + "...";
      }

      // Check if session is currently canceled
      const isCanceled =
        isCurrentlyCanceled !== null
          ? isCurrentlyCanceled
          : this.isSessionCurrentlyCanceled(sched);

      // Add cancellation indicator
      if (isCanceled) {
        const canceledLabel = this.$i18n.locale === "fr" ? "ANNULÉ" : "ملغي";
        title = `❌ ${title}\n🚫 ${canceledLabel}`;
        if (sched.cancellationReason) {
          title = `${title}\n📝 ${sched.cancellationReason}`;
        }
      }

      // Add teacher name if available and not hidden
      if (sched.teacher && sched.teacher.employee && !isVeryShortSession) {
        const teacherName = `${sched.teacher.employee.firstName || ""} ${
          sched.teacher.employee.lastName || ""
        }`.trim();
        if (teacherName) {
          const teacherLabel = this.$t("emploi.enseignant");
          title = `${title}\n ${teacherLabel}: ${teacherName}`;
        }
      }

      // Add room name if available
      if (sched.room && sched.room.name && !isVeryShortSession) {
        const roomLabel = this.$t("emploi.salle");
        title = `${title}\n ${roomLabel}: ${sched.room.name}`;
      }

      // Only add group info for longer sessions to save space
      if (sched.group && sched.group.name && !isVeryShortSession) {
        const groupLabel = this.$t("schedule.group");
        title = `${title}\n● ${groupLabel}: ${sched.group.name}`;
      }

      // Only add week info for longer sessions
      if ((sched.week === "A" || sched.week === "B") && !isVeryShortSession) {
        const weekLabel = this.$t("schedule.week");
        const weekDisplay =
          sched.week === "A"
            ? this.$t("schedule.weekA")
            : this.$t("schedule.weekB");
        title = `${title}\n▶ ${weekLabel} ${weekDisplay}`;
      }

      return title;
    },
    getEventClasses(sched, allSessions = []) {
      if (!sched || typeof sched !== "object") {
        return "regular-event";
      }

      const classes = [];
      const duration = Number(sched.duration) || 60; // Duration in minutes

      if (sched.week === "A" || sched.week === "B")
        classes.push("biweekly-event");
      if (sched.group && sched.group.name) classes.push("group-event");
      if (Number(sched.duration) <= 60) classes.push("short-event"); // 60 minutes = 1 hour
      // More granular duration-based classes
      if (duration < 30) {
        classes.push("very-short-event"); // Less than 30 minutes
      } else if (duration >= 120) {
        classes.push("long-event"); // 2 hours or more
      }
      if (this.hasOverlappingSessions(sched, allSessions)) {
        classes.push("overlapping-event");
      }
      return classes.length > 0 ? classes.join(" ") : "regular-event";
    },
    hasOverlappingSessions(currentSession, allSessions) {
      if (!allSessions || allSessions.length === 0) {
        return false;
      }

      // Count sessions that start at the same time and day
      const overlappingCount = allSessions.filter((session) => {
        return (
          session._id !== currentSession._id && // Not the same session
          session.time === currentSession.time && // Same start time
          session.day === currentSession.day && // Same day
          session.week === currentSession.week
        ); // Same week (or both null/undefined)
      }).length;

      return overlappingCount > 0;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const mo = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${mo}-${d}`;
    },
    createBiweeklyEvents(sched, _info, startTime, endTime, baseEvent) {
      const schoolYear = this.settings.schoolarYears.find(
        (year) => year._id === this.settings.activeSchoolarYear
      );

      if (!schoolYear || !schoolYear.start) {
        return null;
      }

      // Find the Monday of the school year start week
      const academicYearStart = moment(schoolYear.start)
        .startOf("isoWeek")
        .toDate();

      const events = [];
      const currentDate = new Date(_info.start);
      const endDate = _info.end;

      while (currentDate <= endDate) {
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek === Number(sched.day) + 1) {
          // Calculate the Monday of the current date's week
          const currentWeekMonday = moment(currentDate)
            .startOf("isoWeek")
            .toDate();

          // Calculate weeks between the school year start Monday and current date's Monday
          const weekNumber = Math.floor(
            (currentWeekMonday.getTime() - academicYearStart.getTime()) /
              (7 * 24 * 60 * 60 * 1000)
          );
          const isWeekA = weekNumber % 2 === 0;

          if (
            (sched.week === "A" && isWeekA) ||
            (sched.week === "B" && !isWeekA)
          ) {
            const eventDate = this.formatDate(currentDate);
            events.push({
              ...baseEvent,
              id: `${sched._id}-${eventDate}`,
              start: `${eventDate}T${startTime}`,
              end: `${eventDate}T${endTime}`,
            });
          }
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return events.length > 0 ? events : null;
    },
    fcDateClick(info) {
      // Ignore Sunday (0)
      const dow = info.date.getDay();
      if (dow === 0) return;
      const day = dow - 1;
      this.showUpdateDrawer(null, day, this.toQuarterHourTime(info.date));
    },
    toQuarterHourTime(date) {
      const total =
        Math.round((date.getHours() * 60 + date.getMinutes()) / 15) * 15;
      const toTwo = (n) => (n < 10 ? `0${n}` : `${n}`);
      return `${toTwo(Math.floor(total / 60))}:${toTwo(total % 60)}`;
    },
    fcRangeSelect(info) {
      // Handle range selection (when user selects multiple time slots)
      // Ignore Sunday (0)
      const dow = info.start.getDay();
      if (dow === 0) return;

      const day = dow - 1;

      // Open the add modal without setting duration
      this.showUpdateDrawer(null, day, this.toQuarterHourTime(info.start));

      // Clear the selection to avoid visual clutter
      if (this.$refs.calendar) {
        this.$refs.calendar.getApi().unselect();
      }
    },
    fcEventClick(info) {
      const eventId = info.event.id.includes("-")
        ? info.event.id.split("-")[0]
        : info.event.id;
      const record =
        info.event.extendedProps && info.event.extendedProps.record
          ? info.event.extendedProps.record
          : (this.data || []).find((d) => d._id === eventId);

      // Handle both new format (specific dates) and legacy format (day numbers)
      let day;
      if (
        record &&
        (record.day instanceof Date || typeof record.day === "string")
      ) {
        // New format: day is a specific date, calculate day of week
        const sessionDate = new Date(record.day);
        const dow = sessionDate.getDay();
        day = dow === 0 ? 0 : dow - 1; // Convert to 0-5 format (Monday=0, Sunday=0)
      } else {
        // Legacy format: day is already a number (0-5)
        const dow = info.event.start.getDay();
        day = dow === 0 ? 0 : dow - 1;
      }

      const hours = info.event.start.getHours();
      const minutes = info.event.start.getMinutes();
      const toTwo = (n) => (n < 10 ? `0${n}` : `${n}`);
      const time = `${toTwo(hours)}:${toTwo(minutes)}`;
      this.showUpdateDrawer(record, day, time);
    },
    fcEventDrop(info) {
      // Drag moved: update day/time, keep duration from record
      this.handleCalendarEventChange(info, (record) => record.duration);
    },
    fcEventResize(info) {
      this.handleCalendarEventChange(info, () => {
        const diffMinutes = Math.round(
          (info.event.end - info.event.start) / 60000
        );
        // Snap to 15 minutes within the range accepted by the server (15 min – 4 h)
        return Math.min(
          240,
          Math.max(15, Math.round(diffMinutes / 15) * 15)
        );
      });
    },
    handleCalendarEventChange(info, getDuration) {
      const revert = () => info.revert();

      // Only one pending update at a time
      if (
        this.updateLoading ||
        this.dragUpdateModalVisible ||
        this.showCalendarModal
      ) {
        revert();
        return;
      }

      const eventId = info.event.id.includes("-")
        ? info.event.id.split("-")[0]
        : info.event.id;
      const record = (this.data || []).find((d) => d._id === eventId);
      const start = info.event.start;
      if (!record || !start || !info.event.end || start.getDay() === 0) {
        revert();
        return;
      }

      const toTwo = (n) => (n < 10 ? `0${n}` : `${n}`);
      const time = `${toTwo(start.getHours())}:${toTwo(start.getMinutes())}`;
      const day =
        record.day instanceof Date || typeof record.day === "string"
          ? start
          : start.getDay() - 1;

      this.handleUpdateDrag(record._id, day, time, getDuration(record), revert);
    },
    fcDatesSet(info) {
      // Update the selected week when calendar view changes
      let newWeekStart = null;
      let startDate = null;
      let endDate = null;

      if (
        info.view.type === "timeGridWeek" ||
        info.view.type === "dayGridWeek"
      ) {
        newWeekStart = new Date(info.start);
        newWeekStart.setDate(
          newWeekStart.getDate() - newWeekStart.getDay() + 1
        );
        newWeekStart.setHours(0, 0, 0, 0);
      } else if (info.view.type === "timeGridDay") {
        // For day view, set the week start to the beginning of the week containing that day
        const dayDate = new Date(info.start);
        newWeekStart = new Date(dayDate);
        newWeekStart.setDate(dayDate.getDate() - dayDate.getDay() + 1); // Monday
        newWeekStart.setHours(0, 0, 0, 0);
      } else if (info.view.type === "dayGridMonth") {

        const monthStart = new Date(info.start);
        monthStart.setDate(1);
        monthStart.setHours(0, 0, 0, 0);

        const monthEnd = new Date(info.end);
        monthEnd.setDate(monthEnd.getDate() - 1);
        monthEnd.setHours(23, 59, 59, 999);

        startDate = monthStart;
        endDate = monthEnd;
        newWeekStart = monthStart; // Set for compatibility
      }

      if (newWeekStart) {
        if (
          !this.selectedWeekStart ||
          newWeekStart.getTime() !== this.selectedWeekStart.getTime()
        ) {

          this.$set(this, "selectedWeekStart", newWeekStart);
          this.fetchScheduleData(startDate, endDate).then((data) => {
            if (data) {
              this.data = data.filter(
                (sched) => sched.classeRoom._id == this.selectedClasse
              );
              this.dataAllClasses = data;
              this.refreshCalendar();
            }
          });
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      }

      // Update the add session button visibility
      this.$nextTick(() => {
        this.updateAddSessionButton();
      });
    },
    confirmScheduleValidation() {
      const content = this.isValidatedSchedule[this.selectedClasse]
        ? this.$t("emploi.hideEmploi", { name: this.selectedClassName })
        : this.$t("emploi.validateEmploi", { name: this.selectedClassName });
      this.$confirm({
        title: this.$t("all.sureTo"),
        content: (h) => <div style="color:red"> {content} </div>,
        onOk: () => {
          this.updateScheduleValidation();
        },
        onCancel: () => {},
        class: "test",
      });
    },
    updateScheduleValidation() {
      const newState = !this.isValidatedSchedule[this.selectedClasse];
      apiClient
        .patch("/classrooms/" + this.selectedClasse, {
          data: { schedule: newState },
        })
        .then((res) => {
          if (newState)
            this.$message.success(
              this.$t("emploi.validated", { name: this.selectedClassName })
            );
          else
            this.$message.success(
              this.$t("emploi.unvalidated", { name: this.selectedClassName })
            );
          this.selectedClassValidedSchedule = newState;
          this.isValidatedSchedule[this.selectedClasse] = newState;
        })
        .catch((e) => this.$message.danger(this.$t("error.impoModifi")));
    },
    toggleHideTeacher(checked) {
      this.hideTeacherLoading = true;
      this.justUpdatedHideTeacher = true; // Set flag to prevent override
      apiClient
        .patch("/classrooms/" + this.selectedClasse, {
          data: { hideTeacher: checked },
        })
        .then((res) => {
          this.$message.success(
            this.$t("emploi.hideTeacherUpdated", {
              name: this.selectedClassName,
              status: checked
                ? this.$t("emploi.hidden")
                : this.$t("emploi.visible"),
            })
          );
          this.selectedClassHideTeacher = checked;
          // Update the classroom data in local state to maintain consistency
          const selectedClass = this.classes.find(
            (item) => item._id === this.selectedClasse
          );
          if (selectedClass) {
            selectedClass.hideTeacher = checked;
          }
          // Refresh calendar data to stay in sync with backend
          this.reloadScheduleData();
        })
        .catch((e) => {
          this.$message.danger(this.$t("error.impoModifi"));
          // Revert the switch state on error
          this.selectedClassHideTeacher = !checked;
          // Reset the flag on error
          this.justUpdatedHideTeacher = false;
        })
        .finally(() => {
          this.hideTeacherLoading = false;
        });
    },
    handleSubjectSelectChange(value) {
      // Find the selected item (module or subject)
      const selectedItem = this.allSubjects.find((item) => item._id === value);

      if (selectedItem) {
        // Use $nextTick to ensure the form is ready before setting the value
        this.$nextTick(() => {
          this.form.setFieldsValue({ name: selectedItem.name });
        });

        if (selectedItem.isModule) {
          // If a module is selected, get all its subjects
          if (selectedItem.subjects && Array.isArray(selectedItem.subjects)) {
            this.includedSubjects = selectedItem.subjects.map((s) => s._id);
          } else {
            this.includedSubjects = [];
          }
        } else if (selectedItem.moduleId) {
          // If a subject from a module is selected, get all subjects from that module
          const originalModule = this.modules.find(
            (mod) => mod._id === selectedItem.moduleId
          );
          if (originalModule && originalModule.subjects) {
            this.includedSubjects = originalModule.subjects.map((s) => s._id);
          } else {
            this.includedSubjects = [];
          }
        } else {
          // If a direct subject is selected
          this.includedSubjects = [];
        }
      }
    },
    async handleClassChange(value) {
      const selectedClass = this.classes.find((item) => item._id === value);
      if (!selectedClass) return;

      this.selectedLevel = selectedClass.level;
      this.selectedClassName = selectedClass.name;
      this.selectedClassValidedSchedule =
        this.isValidatedSchedule[this.selectedClasse];
      this.selectedClassHideTeacher = selectedClass.hideTeacher || false;

      // Reset subjects/modules
      this.modules = [];
      this.subjects = [];

      try {
        // Load modules/subjects and groups in parallel
        const [modulesRes, groupsRes] = await Promise.all([
          apiClient.post("/schedules/modules-subjects", {
            query: { level: Number(this.selectedLevel), status: "active" },
          }),
          apiClient
            .post("/scheduleGroup/byClassroom", { classeRoom: value })
            .catch(() => ({ data: { groups: [] } })),
        ]);

        const modulesGeneral = Array.isArray(modulesRes.data.modulesGeneral)
          ? modulesRes.data.modulesGeneral
          : [];
        const activeSubjects = Array.isArray(modulesRes.data.subjects)
          ? modulesRes.data.subjects
          : [];

        // Keep all modules together (no type separation)
        this.modules = modulesGeneral.filter((m) => m.status === "active");

        // Build subjects from modules (unique, active)
        const subjectsSet = new Map();
        const collectSubjects = (mods) => {
          mods.forEach((mod) => {
            (mod.subjects || [])
              .filter((s) => s && s.status !== "inactive")
              .forEach((s) => {
                if (!subjectsSet.has(String(s._id))) {
                  subjectsSet.set(String(s._id), {
                    ...s,
                    moduleId: mod._id,
                  });
                }
              });
          });
        };
        collectSubjects(this.modules);

        // Add remaining active subjects
        activeSubjects
          .filter((s) => s && s.status === "active")
          .forEach((s) => {
            if (!subjectsSet.has(String(s._id))) {
              subjectsSet.set(String(s._id), {
                ...s,
              });
            }
          });

        this.subjects = Array.from(subjectsSet.values());
        this.groups = Array.isArray(groupsRes.data.groups)
          ? groupsRes.data.groups
          : [];
      } catch (error) {
        this.$message.error(this.$t("error.error"));
        this.groups = [];
      }
    },
    refreshDrawerAvailability(record, day, time) {
      let dayQuery;
      if (
        record &&
        (record.day instanceof Date || typeof record.day === "string")
      ) {
        // New format: use the specific date for availability check
        dayQuery = new Date(record.day);
      } else {
        // Legacy format: use the day number
        dayQuery = day;
      }

      apiClient
        .post("/schedules/disponiblity/filter", {
          query: {
            who: "class",
            time,
            day: dayQuery,
            classroom: this.selectedClasse,
          },
        })
        .then(({ data }) => {
          this.filtredTeachers = data.teachers;
          this.filtredRooms = data.rooms;
        });
    },
    handleDrawerTimeChange(time) {
      if (!time) return;
      this.selectedTime = time.format("HH:mm");
      this.refreshDrawerAvailability(
        this.selectedSchedule,
        this.selectedDay,
        this.selectedTime
      );
    },
    showUpdateDrawer(record, day, time) {
      this.refreshDrawerAvailability(record, day, time);

      if (!this.selectedClasse) {
        this.$message.error(this.$t("error.selectClasse"));
        return;
      }
      this.selectedDay = day;
      this.selectedTime = time;
      if (record) {
        this.selectedSchedule = record;

        // Handle teacher data safely - show only if available
        this.fullTeacherName = "No teacher data";
        if (record.teacher && record.teacher.employee) {
          const firstName = record.teacher.employee.firstName || "";
          const lastName = record.teacher.employee.lastName || "";
          const fullName = `${lastName} ${firstName}`.trim();
          this.fullTeacherName = fullName || "Teacher name incomplete";
        } else if (record.teacher) {
          this.fullTeacherName = "Teacher data incomplete";
        }

        // Handle subject data safely
        let selectedItem = null;
        if (record.subject && record.subject._id) {
          selectedItem = this.allSubjects.find(
            (s) => s._id == record.subject._id
          );
        }

        if (selectedItem && selectedItem.isModule) {
          // If it's a module, get all its subjects
          if (record.includedSubjects) {
            this.includedSubjects = record.includedSubjects;
          } else if (
            selectedItem.subjects &&
            Array.isArray(selectedItem.subjects)
          ) {
            this.includedSubjects = selectedItem.subjects.map((s) => s._id);
          } else {
            this.includedSubjects = [];
          }
        } else if (selectedItem && selectedItem.moduleId) {
          // If it's a subject from a module
          if (record.includedSubjects) {
            this.includedSubjects = record.includedSubjects;
          } else {
            // Find the original module to get its subjects
            const originalModule = this.modules.find(
              (mod) => mod._id === selectedItem.moduleId
            );
            if (originalModule && originalModule.subjects) {
              this.includedSubjects = originalModule.subjects.map((s) => s._id);
            } else {
              this.includedSubjects = [];
            }
          }
        } else {
          this.includedSubjects = [];
        }

        // Populate form fields with existing data - only set fields that have data
        this.$nextTick(() => {
          const formData = {};

          // Only set teacher if it exists and has an ID
          if (record.teacher && record.teacher._id) {
            formData.teacher = record.teacher._id;
          }

          // Only set subject if it exists and has an ID
          if (record.subject && record.subject._id) {
            formData.subject = record.subject._id;
          }

          // Only set room if it exists and has an ID
          if (record.room && record.room._id) {
            formData.room = record.room._id;
          }

          // Only set group if it exists and has an ID
          if (record.group && record.group._id) {
            formData.group = record.group._id;
          }

          // Set other fields if they exist
          if (record.week) {
            formData.week = record.week;
          }
          if (record.duration) {
            formData.duration = record.duration;
          }

          // Set name - prioritize record.name, fallback to subject.name
          const sessionName =
            record.name || (record.subject && record.subject.name) || "";
          if (sessionName) {
            formData.name = sessionName;
          }

          this.form.setFieldsValue(formData);
        });

        this.updateVisible = true;
      } else {
        this.visible = true;
      }
    },
    showDrawer() {
      if (!this.selectedClasse) {
        this.$message.error(this.$t("error.selectClasse"));
        return;
      }
      this.visible = true;
    },
    onClose() {
      this.visible = false;
      this.updateVisible = false;
      this.selectedDay = null;
      this.selectedTime = null;
      this.selectedSchedule = null;
      this.submitError = null;
      this.pendingUpdateData = null;
      this.form.resetFields();
    },
    handleSubmit(e) {
      this.submitError = null;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loadingAddBtn = true;
          values.classeRoom = this.selectedClasse;
          values.trimester = this.selectedTrimester;
          values.day = this.selectedDay; // This should be a number (0-5) for recurring schedules
          values.time = this.selectedTime;
          values.group = values.group || null;
          values.week = values.week || null;

          const selectedItem = this.allSubjects.find(
            (s) => s._id === values.subject
          );
          if (selectedItem && selectedItem.isModule) {
            // For modules, use moduleGeneral field
            values.moduleGeneral = selectedItem._id;
            values.subject = null;
          } else if (selectedItem && selectedItem.moduleId) {
            // For subjects from modules, use moduleGeneral field
            values.moduleGeneral = selectedItem.moduleId;
            values.subject = null;
          } else {
            // For regular subjects, use subject field
            values.subject = values.subject;
            values.moduleGeneral = null;
          }

          // Validate timetable limits before submitting
          if (
            !this.validateTimetableLimits(
              values.time,
              values.duration,
              values.day
            )
          ) {
            this.loadingAddBtn = false;
            return;
          }

          apiClient
            .put(`/schedules`, { data: values })
            .then((res) => {

              let sessionsArray = null;
              if (Array.isArray(res.data)) {
                sessionsArray = res.data;
              } else if (res.data.sessions && Array.isArray(res.data.sessions)) {
                sessionsArray = res.data.sessions;
              }

              if (sessionsArray && sessionsArray.length > 0) {
                const sessionsToAdd = sessionsArray.map((session) => {
                  const displaySubject = session.subject
                    ? session.subject
                    : session.moduleGeneral;

                  // Safely handle teacher data with fallbacks
                  const teacherData = session.teacher || {};
                  const employeeData = teacherData.employee || {};

                  return {
                    classeRoom: {
                      _id: session.classeRoom?._id || session.classeRoom,
                      name:
                        session.classeRoom?.name ||
                        this.$t("schedule.unknownClass"),
                    },
                    day: session.day,
                    duration: session.duration,
                    ends: session.ends,
                    room: {
                      name: session.room?.name || "",
                      _id: session.room?._id || session.room || null,
                    },
                    subject: displaySubject
                      ? { name: displaySubject.name, _id: displaySubject._id }
                      : { name: "", _id: null },
                    teacher: {
                      _id: teacherData._id || teacherData,
                      employee: {
                        firstName:
                          employeeData.firstName || this.$t("schedule.unknown"),
                        lastName:
                          employeeData.lastName || this.$t("schedule.teacher"),
                      },
                    },
                    time: session.time,
                    _id: session._id,
                    name: session.name,
                    week: session.week || null,
                    group: session.group || null,
                    includedSubjects: session.includedSubjects,
                  };
                });

                // Add all sessions to the data arrays
                this.data.push(...sessionsToAdd);
                this.dataAllClasses.push(...sessionsToAdd);

                // Show success message with count
                this.$message.success(this.$t("success.seanceAjout"));
              } else {
                // Fallback for single session (backward compatibility)
                const displaySubject = res.data.subject
                  ? res.data.subject
                  : res.data.moduleGeneral;

                // Safely handle teacher data with fallbacks
                const teacherData = res.data.teacher || {};
                const employeeData = teacherData.employee || {};

                let newData = {
                  classeRoom: {
                    _id: res.data.classeRoom?._id || res.data.classeRoom,
                    name:
                      res.data.classeRoom?.name ||
                      this.$t("schedule.unknownClass"),
                  },
                  day: res.data.day,
                  duration: res.data.duration,
                  ends: res.data.ends,
                  room: {
                    name: res.data.room?.name || "",
                    _id: res.data.room?._id || res.data.room || null,
                  },
                  subject: displaySubject
                    ? { name: displaySubject.name, _id: displaySubject._id }
                    : { name: "", _id: null },
                  teacher: {
                    _id: teacherData._id || teacherData,
                    employee: {
                      firstName:
                        employeeData.firstName || this.$t("schedule.unknown"),
                      lastName:
                        employeeData.lastName || this.$t("schedule.teacher"),
                    },
                  },
                  time: res.data.time,
                  _id: res.data._id,
                  name: res.data.name,
                  week: res.data.week || null,
                  group: res.data.group || null,
                  includedSubjects: res.data.includedSubjects,
                };

                this.data.push(newData);
                this.dataAllClasses.push(newData);
                this.$message.success(this.$t("success.seanceAjout"));
              }

              // Close modal and refresh calendar
              this.onClose();

              // Force calendar refresh with a small delay to ensure DOM updates
              this.$nextTick(() => {
                setTimeout(() => {
                  this.refreshCalendar();
                }, 100);
              });
            })
            .catch((e) => {
              if (e.response && e.response.status == 400) {
                const conflictType = e.response.data.conflictType;
                const conflictDescription = this.formatConflictSessionDescription(
                  e.response.data
                );

                if (e.response.data.errorId == 1) {
                  // Classroom conflicts
                  let schedule = e.response.data.schedule;
                  let errorMessage;

                  if (conflictType === "future_pattern") {
                    const sessionHasGroup =
                      schedule?.group &&
                      schedule.group.toString().trim() !== "";
                    const newSessionHasGroup =
                      values.group && values.group.toString().trim() !== "";

                    if (
                      sessionHasGroup &&
                      newSessionHasGroup &&
                      schedule.group.toString() !== values.group.toString()
                    ) {
                      errorMessage = this.$t("error.classroomGroupConflict");
                    } else if (sessionHasGroup && !newSessionHasGroup) {
                      errorMessage = this.$t("error.classroomMixedConflict");
                    } else {
                      errorMessage = this.$t("error.classeIndis");
                    }
                  } else {
                    errorMessage = this.$t("error.classeIndis");
                  }

                  this.$message.error(errorMessage);
                  this.submitError = {
                    message: errorMessage,
                    description: conflictDescription,
                  };
                }

                if (e.response.data.errorId == 2) {
                  // Teacher conflicts
                  let schedule = e.response.data.schedule;
                  let errorMessage;

                  if (conflictType === "teacher_future_pattern") {
                    const sessionHasGroup =
                      schedule?.group &&
                      schedule.group.toString().trim() !== "";
                    const newSessionHasGroup =
                      values.group && values.group.toString().trim() !== "";

                    if (
                      sessionHasGroup &&
                      newSessionHasGroup &&
                      schedule.group.toString() !== values.group.toString()
                    ) {
                      errorMessage = this.$t("error.teacherGroupConflict");
                    } else if (sessionHasGroup && !newSessionHasGroup) {
                      errorMessage = this.$t("error.teacherMixedConflict");
                    } else {
                      errorMessage = this.$t("error.enseignantIndis");
                    }
                  } else {
                    errorMessage = this.$t("error.enseignantIndis");
                  }

                  this.$message.error(errorMessage);
                  this.submitError = {
                    message: errorMessage,
                    description: conflictDescription,
                  };
                }

                if (e.response.data.errorId == 3) {
                  let schedule = e.response.data.schedule;
                  this.$message.error(this.$t("error.salleIndis"));
                  this.submitError = {
                    message: this.$t("error.salleIndis"),
                    description: this.$t("error.sallePriseEntre", {
                      room: schedule?.room?.name || "-",
                      name: schedule?.classeRoom?.name || "-",
                      start: schedule?.time || "-",
                      end: schedule?.ends || "-",
                    }),
                  };
                }

                if (e.response.data.errorId == 4) {
                  this.$message.error(this.$t("error.capacite"));
                }
              } else {
                // Handle other types of errors
                this.$message.error(
                  this.$t("error.error") ||
                    this.$t("schedule.errorCreatingSession")
                );
              }
            })
            .finally(() => (this.loadingAddBtn = false));
        }
      });
    },
    // `day` is a Date for dated sessions, or a weekday number (Mon=0) for legacy ones
    handleUpdateDrag(index, day, time, duration, revert) {
      this.errorDrag = false;

      const schedule = this.data.find((el) => el._id == index);

      if (!schedule) {
        this.$message.error(this.$t("schedule.scheduleNotFound"));
        revert();
        this.refreshCalendar();
        return;
      }

      const isDate = day instanceof Date;
      const dayOfWeek = isDate
        ? day.getDay() === 0
          ? 6
          : day.getDay() - 1
        : day;

      if (!this.validateTimetableLimits(time, duration, dayOfWeek)) {
        revert();
        return;
      }

      const values = {
        classeRoom: this.selectedClasse,
        trimester: this.selectedTrimester,
        time: time,
        day: isDate ? this.formatDate(day) : day,
        duration: duration,
        teacher: schedule.teacher ? schedule.teacher._id : null,
        room: schedule.room ? schedule.room._id : null,
        group: schedule.group ? schedule.group._id : null,
        week: schedule.week || null,
      };
      if (schedule.name) {
        values.name = schedule.name;
      }

      const moduleId =
        (schedule.moduleGeneral && schedule.moduleGeneral._id) ||
        schedule.moduleGeneral;
      if (moduleId) {
        values.moduleGeneral = moduleId;
        values.subject = null;
      } else {
        values.subject = schedule.subject ? schedule.subject._id : null;
        values.moduleGeneral = null;
      }

      this.selectedSchedule = schedule;
      this.pendingUpdateData = values;
      this.pendingRevert = revert;
      this.dragUpdateModalVisible = true;
    },
    confirmDragUpdateAll() {
      this.dragUpdateModalVisible = false;
      this.showCalendarModal = true;
    },
    confirmDragUpdateSingle() {
      this.dragUpdateModalVisible = false;
      this.performSingleUpdate();
    },
    openBulkUpdateCalendar() {
      if (!this.pendingUpdateData) return;
      this.showCalendarModal = true;
    },
    revertPendingDrag() {
      if (this.pendingRevert) {
        this.pendingRevert();
        this.pendingRevert = null;
      }
    },
    cancelPendingUpdate() {
      this.dragUpdateModalVisible = false;
      this.showCalendarModal = false;
      this.revertPendingDrag();
      this.pendingUpdateData = null;
      this.customEndDate = null;
    },
    handleUpdate(e) {
      this.submitError = null;
      this.pendingUpdateData = null;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          values.classeRoom = this.selectedClasse;
          values.trimester = this.selectedTrimester;
          values.time = this.selectedTime;

          // Handle both new format (specific dates) and legacy format (day numbers)
          if (
            this.selectedSchedule &&
            (this.selectedSchedule.day instanceof Date ||
              typeof this.selectedSchedule.day === "string")
          ) {
            // New format: keep the original specific date
            values.day = this.selectedSchedule.day;
          } else {
            // Legacy format: use the selected day number
            values.day = this.selectedDay;
          }

          // Optional group/week
          values.group = values.group || null;
          values.week = values.week || null;

          const selectedItem = this.allSubjects.find(
            (s) => s._id === values.subject
          );
          if (selectedItem && selectedItem.isModule) {
            // For modules, use moduleGeneral field
            values.moduleGeneral = selectedItem._id;
            values.subject = null;
          } else if (selectedItem && selectedItem.moduleId) {
            // For subjects from modules, use moduleGeneral field
            values.moduleGeneral = selectedItem.moduleId;
            values.subject = null;
          } else {
            // For regular subjects, use subject field
            values.subject = values.subject;
            values.moduleGeneral = null;
          }

          // remove includedSubjects in update modal per new model
          values.includedSubjects = null;
          if (!values.name) delete values.name;

          const dayOfWeek =
            typeof values.day === "number"
              ? values.day
              : (new Date(values.day).getUTCDay() + 6) % 7;

          // Validate timetable limits before storing data
          if (
            !this.validateTimetableLimits(
              values.time,
              values.duration,
              dayOfWeek
            )
          ) {
            return;
          }

          // Store data for Popconfirm
          this.pendingUpdateData = values;
        }
      });
    },
    filterOption(input, option) {
      if (!input) return true;

      // Extract text content from the option
      const extractText = (node) => {
        if (typeof node === "string") return node;
        if (node && node.text) return node.text;
        if (node && node.children) {
          return node.children.map(extractText).join(" ").trim();
        }
        return "";
      };

      let text = "";

      // Handle different option structures
      if (option.componentOptions && option.componentOptions.children) {
        // For regular options with complex children (icons + text + tags)
        text = option.componentOptions.children
          .map(extractText)
          .join(" ")
          .trim();
      } else if (option.children) {
        // For opt-group options
        text = option.children.map(extractText).join(" ").trim();
      } else if (typeof option === "string") {
        text = option;
      }

      // Clean up the text and perform search
      text = text.replace(/\s+/g, " ").trim();
      return text.toLowerCase().includes(input.toLowerCase());
    },
    deleteSchedule() {
      if (this.selectedSchedule) {
        this.showDeleteConfirmationModal();
      }
    },
    formatConflictSessionDescription(responseData = {}) {
      const details = responseData.details || {};
      const schedule = responseData.schedule || {};
      const teacherFromSchedule =
        schedule.teacher && schedule.teacher.employee
          ? `${schedule.teacher.employee.firstName || ""} ${
              schedule.teacher.employee.lastName || ""
            }`.trim()
          : "";
      const subject =
        details.subjectName ||
        schedule.name ||
        schedule.moduleGeneral?.name ||
        schedule.subject?.name ||
        "-";
      const teacher = details.teacherName || teacherFromSchedule || "-";
      const className =
        details.className || schedule.classeRoom?.name || "-";
      const start = details.time || schedule.time || "-";
      const end = details.endTime || schedule.ends || "-";
      const date =
        details.conflictDate ||
        (schedule.day ? moment(schedule.day).format("YYYY-MM-DD") : "-");
      const extras = [];
      if (details.groupName || schedule.group?.name) {
        extras.push(
          `${this.$t("error.conflictGroup")}: ${
            details.groupName || schedule.group.name
          }`
        );
      }
      if (details.week || schedule.week) {
        extras.push(
          `${this.$t("error.conflictWeek")}: ${details.week || schedule.week}`
        );
      }
      const extra = extras.length ? ` (${extras.join(", ")})` : "";

      return this.$t("error.conflictingSessionInfo", {
        subject,
        teacher,
        className,
        date,
        start,
        end,
        extra,
      });
    },
    showDeleteConfirmationModal() {
      const session = this.selectedSchedule;
      const sessionName =
        session.subject?.name ||
        session.moduleGeneral?.name ||
        this.$t("schedule.session");
      const sessionDate = moment(session.day).format("DD/MM/YYYY");
      const sessionTime = session.time;
      const classroomName =
        session.classeRoom?.name || this.$t("schedule.classroom");

      // Set the session info for the modal
      this.deleteSessionInfo = {
        sessionName,
        sessionDate,
        sessionTime,
        classroomName,
      };

      // Show the modal
      this.deleteModalVisible = true;
    },
    handleDeleteSingle() {
      this.deleteModalVisible = false;
      this.deleteSingleSession();
    },
    handleDeleteRecurring() {
      this.deleteModalVisible = false;
      this.deleteRecurringSessions();
    },
    deleteSingleSession() {
      if (this.selectedSchedule) {
        apiClient
          .delete(`/schedules/session/` + this.selectedSchedule._id, {
            data: { deleteRecurring: false },
          })
          .then((response) => {
            this.$message.success(this.$t("success.seanceSupp"));
            this.data = this.data.filter(
              (el) => el._id != this.selectedSchedule._id
            );
            this.dataAllClasses = this.dataAllClasses.filter(
              (el) => el._id != this.selectedSchedule._id
            );
            this.onClose();
            this.refreshCalendar();
          })
          .catch((e) => {
            this.$message.error(this.$t("error.deleteSession"));
          });
      }
    },
    deleteRecurringSessions() {
      if (this.selectedSchedule) {
        apiClient
          .delete(`/schedules/session/` + this.selectedSchedule._id, {
            data: { deleteRecurring: true },
          })
          .then((response) => {
            const deletedCount = response.data.deletedCount;
            this.$message.success(
              this.$t("success.recurringSessionsDeleted", {
                count: deletedCount,
              })
            );

            // Remove all deleted sessions from local data
            const deletedSessionIds = response.data.deletedSessions || [
              this.selectedSchedule._id,
            ];
            this.data = this.data.filter(
              (el) => !deletedSessionIds.includes(el._id)
            );
            this.dataAllClasses = this.dataAllClasses.filter(
              (el) => !deletedSessionIds.includes(el._id)
            );

            this.onClose();
            this.refreshCalendar();
          })
          .catch((e) => {
            this.$message.error(this.$t("error.deleteRecurringSessions"));
          });
      }
    },
    showCancelModal() {
      this.cancelModalVisible = true;
      this.cancellationReason = "";
      this.canceledUntil = null;
    },
    handleCancelSession() {
      if (!this.cancellationReason || this.cancellationReason.trim() === "") {
        this.$message.error(this.$t("emploi.cancellationReasonRequired"));
        return;
      }

      if (!this.canceledUntil) {
        this.$message.error(this.$t("emploi.cancelUntilRequired"));
        return;
      }

      // Check if the date is not in the past
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(this.canceledUntil);

      if (selectedDate < today) {
        this.$message.error(this.$t("emploi.cancelUntilCannotBePast"));
        return;
      }

      this.cancelLoading = true;

      apiClient
        .patch(`/schedules/session/${this.selectedSchedule._id}/cancel`, {
          cancellationReason: this.cancellationReason.trim(),
          canceledUntil: this.canceledUntil,
        })
        .then((response) => {
          this.$message.success(
            this.$t("success.sessionsCanceled", {
              count: response.data.canceledCount,
            })
          );

          // Update all canceled sessions in local data
          if (response.data.sessions && Array.isArray(response.data.sessions)) {
            response.data.sessions.forEach((updatedSession) => {
              const sessionIndex = this.data.findIndex(
                (el) => el._id === updatedSession._id
              );
              if (sessionIndex !== -1) {
                this.data.splice(sessionIndex, 1, updatedSession);
              }

              const allSessionIndex = this.dataAllClasses.findIndex(
                (el) => el._id === updatedSession._id
              );
              if (allSessionIndex !== -1) {
                this.dataAllClasses.splice(allSessionIndex, 1, updatedSession);
              }
            });
          }

          this.cancelModalVisible = false;
          this.cancellationReason = "";
          this.canceledUntil = null;
          this.onClose();
          this.refreshCalendar();
        })
        .catch((e) => {
          this.$message.error(this.$t("error.cancelSession"));
        })
        .finally(() => {
          this.cancelLoading = false;
        });
    },
    restoreSession() {
      this.$confirm({
        title: this.$t("emploi.restoreSession"),
        content: this.$t("emploi.restoreSessionConfirm"),
        onOk: () => {
          apiClient
            .patch(
              `/schedules/session/${this.selectedSchedule._id}/restore`,
              {}
            )
            .then((response) => {
              this.$message.success(
                this.$t("success.sessionsRestored", {
                  count: response.data.restoredCount,
                })
              );

              // Update all restored sessions in local data
              if (
                response.data.sessions &&
                Array.isArray(response.data.sessions)
              ) {
                response.data.sessions.forEach((updatedSession) => {
                  const sessionIndex = this.data.findIndex(
                    (el) => el._id === updatedSession._id
                  );
                  if (sessionIndex !== -1) {
                    this.data.splice(sessionIndex, 1, updatedSession);
                  }

                  const allSessionIndex = this.dataAllClasses.findIndex(
                    (el) => el._id === updatedSession._id
                  );
                  if (allSessionIndex !== -1) {
                    this.dataAllClasses.splice(
                      allSessionIndex,
                      1,
                      updatedSession
                    );
                  }
                });
              }

              this.onClose();
              this.refreshCalendar();
            })
            .catch((e) => {
              this.$message.error(this.$t("error.restoreSession"));
            });
        },
      });
    },
    disabledDate(current) {
      // Disable dates before today
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current && current < today;
    },
    getTimes() {
      if (this.selectedTime) {
        let time = this.selectedTime.split(":");
        let times = [time.join(":")];
        time[1] = Number(time[1]) + 15;
        times[1] = time.join(":");
        time[1] = Number(time[1]) + 15;
        times[2] = time.join(":");
        time[1] = Number(time[1]) + 15;
        times[3] = time.join(":");
        return times;
      }
      return [];
    },
    endTime(time, duration) {
      // Duration is now in minutes (1 slot = 1 minute)
      const [hours, minutes] = time.split(":").map(Number);
      const totalMinutes = minutes + duration;
      const newHours = hours + Math.floor(totalMinutes / 60);
      const newMinutes = totalMinutes % 60;
      return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
    },
    generatePDF(lang = "fr") {
      if (!this.selectedClasse) {
        this.$message.error(this.$t("error.selectClasse"));
        return;
      }

      this.$gtag.event("Imp Emploi classe", {
        event_category: "Impression PDF",

        event_label: "Emploi - classe section",

        value: 1,
      });

      this.loadingPdf = true;

      // Save current locale and temporarily change to target language for translations
      const originalLocale = this.$i18n.locale;
      // Map PDF language to i18n locale
      const localeMap = {
        ar: "ar-AR",
        fr: "fr-FR",
        en: "en-US",
        sw: "sw-KE",
      };
      this.$i18n.locale = localeMap[lang] || "fr-FR";

      // Helper function to calculate appropriate font size for session titles
      const getSessionTitleFontSize = (
        text,
        maxWidth,
        isUnderOneHour,
        compactMode
      ) => {
        if (!text) return 6;

        // Start with base font size
        let baseSize = isUnderOneHour
          ? compactMode
            ? 9
            : 10
          : compactMode
          ? 9
          : 15;

        // Test if text fits at base size
        doc.setFontSize(baseSize);
        const textWidth = doc.getTextWidth(text);

        if (textWidth <= maxWidth - 4) {
          return baseSize;
        }

        // Calculate scale factor to fit the text
        const scaleFactor = (maxWidth - 4) / textWidth;
        const scaledSize = Math.max(baseSize * scaleFactor, 2); // Minimum size of 2

        // For very long text, use even smaller size
        if (text.length > 15) {
          return Math.max(scaledSize * 0.9, 9);
        }

        return Math.max(scaledSize, 2);
      };

      // Define endTime function locally for PDF generation
      // Duration is in minutes (1 slot = 1 minute)
      const endTime = (time, duration) => {
        const [hours, minutes] = time.split(":").map(Number);
        const totalMinutes = minutes + duration;
        const newHours = hours + Math.floor(totalMinutes / 60);
        const newMinutes = totalMinutes % 60;
        return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
      };

      // Define normalizeTime function first

      const normalizeTime = (t) => {
        if (!t) return t;

        // Handle different time formats
        let timeStr = String(t).trim();

        // Handle formats like "8:00", "08:00", "8", "08"
        if (timeStr.includes(":")) {
          const [h, m] = timeStr.split(":");
          return `${String(h).padStart(2, "0")}:${String(m || "0").padStart(
            2,
            "0"
          )}`;
        } else {
          // Handle formats like "8" or "08" (assume minutes are 0)
          const hour = String(timeStr).padStart(2, "0");
          return `${hour}:00`;
        }
      };

      // Helper function to map any time to the nearest 15-minute slot for grid placement
      const mapToGridSlot = (time) => {
        if (!time) return time;
        const normalized = normalizeTime(time);
        const [hours, minutes] = normalized.split(":").map(Number);

        // Map to nearest 15-minute slot
        // 0-7 min -> :00, 8-22 min -> :15, 23-37 min -> :30, 38-52 min -> :45, 53-59 min -> next hour :00
        let gridMinutes;
        if (minutes >= 0 && minutes < 8) {
          gridMinutes = 0;
        } else if (minutes >= 8 && minutes < 23) {
          gridMinutes = 15;
        } else if (minutes >= 23 && minutes < 38) {
          gridMinutes = 30;
        } else if (minutes >= 38 && minutes < 53) {
          gridMinutes = 45;
        } else {
          // 53-59 minutes, map to next hour :00
          return `${String(hours + 1).padStart(2, '0')}:00`;
        }

        return `${String(hours).padStart(2, '0')}:${String(gridMinutes).padStart(2, '0')}`;
      };

      // Helper function to check if a session time matches a time slot

      const matchesTimeSlot = (sessionTime, targetTime) => {
        if (!sessionTime || !targetTime) return false;

        try {
          const normalizedSessionTime = normalizeTime(sessionTime);
          const normalizedTargetTime = normalizeTime(targetTime);

          // Map session time to grid slot for comparison
          const sessionGridSlot = mapToGridSlot(normalizedSessionTime);

          return sessionGridSlot === normalizedTargetTime;
        } catch (error) {
          console.warn(
            `Error matching times: sessionTime=${sessionTime}, targetTime=${targetTime}`,
            error
          );
          return false;
        }
      };
      let dataToUse;

      if (this.data && this.data.length > 0) {
        dataToUse = this.data;
      } else if (this.dataAllClasses && this.dataAllClasses.length > 0) {
        // Filter dataAllClasses for the selected class

        dataToUse = this.dataAllClasses.filter(
          (sched) =>
            sched.classeRoom && sched.classeRoom._id == this.selectedClasse
        );
      } else {
        dataToUse = [];
      }

      // Print the week currently shown on the calendar (not always "today")
      const startOfWeek = this.selectedWeekStart
        ? moment(this.selectedWeekStart).startOf("isoWeek").toDate()
        : moment().startOf("isoWeek").toDate();
      const endOfWeek = moment(startOfWeek).endOf("isoWeek").toDate();
      const printedWeekType = this.currentWeekType; // "A" | "B" | ""

      // Keep sessions that fall in the selected ISO week only
      const selectedIsoWeek = moment(startOfWeek).format("GGGG-WW");
      dataToUse = dataToUse.filter((sched) => {
        let sessionMoment;
        if (sched.day instanceof Date || typeof sched.day === "string") {
          sessionMoment = moment(sched.day);
          if (!sessionMoment.isValid()) {
            return false;
          }
        } else if (typeof sched.day === "number") {
          sessionMoment = moment(startOfWeek).add(Number(sched.day), "days");
        } else {
          return false;
        }

        return sessionMoment.format("GGGG-WW") === selectedIsoWeek;
      });

      const schoolImage = this.settings.image.find(
        (img) => img.db === this.settings.activeBuilding
      );

      let imgData = null;

      if (schoolImage) {
        const img = new Image();

        img.src = schoolImage.logo;

        imgData = img;
      }

      const doc = new JsPDF("landscape");

      const pdfWidth = doc.internal.pageSize.getWidth();

      const schoolDetails = this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
      const schoolNameAr = schoolDetails?.ArabicName;

      const schoolNameFr = schoolDetails?.name;

      const delegation = schoolDetails?.delegeRegional;

      const schoolYear = this.settings.schoolarYears.find(
        (el) => el._id == this.settings.activeSchoolarYear
      );

      const startYear = new Date(schoolYear.start).getFullYear();

      const endYear = new Date(schoolYear.end).getFullYear();

      const schoolarYearName = `${endYear} / ${startYear}`;

      doc.setFont("Amiri"); // Add logo if available

      if (imgData) {
        // Position logo on left for Arabic, right for French
        const logoWidth = 20;
        const logoHeight = 20;
        const logoX = lang === "ar" ? 10 : pdfWidth - (logoWidth + 8);
        doc.addImage(imgData, "JPEG", logoX, 5, logoWidth, logoHeight);
      }

      const today = new Date();

      const options = {
        weekday: "long",

        year: "numeric",

        month: "long",

        day: "numeric",
      };

      const className =
        this.classes.find((el) => el._id == this.selectedClasse)?.name ||
        this.$t("schedule.unknownClass");

      doc.setTextColor(0, 51, 153);

      doc.setFontSize(9); // Use RTL-aware header positioning - reduced from 12

      const headerX = lang === "ar" ? pdfWidth - 10 : 10;

      const headerAlign = lang === "ar" ? "right" : "left";

      doc.text(
        headerX,

        8,

        this.$t("emploi.pdfRepublique"),

        { align: headerAlign }
      );

      const delegationKey =
        this.countryIsTN
          ? "emploi.pdfDelegation"
          : "emploi.pdfDelegationKE";

      doc.text(
        headerX,

        13,

        this.$t(delegationKey, { delegation }),

        { align: headerAlign }
      );

      doc.text(
        headerX,

        18,

        this.$t("emploi.pdfAnnee", { year: schoolarYearName }),

        { align: headerAlign }
      );

      doc.setFontSize(7);

      // Format date based on language
      let formattedDate;
      if (lang === "ar") {
        formattedDate = today
          .toLocaleDateString("ar-TN", options)
          .replace(/،/g, "");
      } else if (lang === "en") {
        formattedDate = today.toLocaleDateString("en-US", options);
      } else if (lang === "sw") {
        formattedDate = today.toLocaleDateString("sw-KE", options);
      } else {
        formattedDate = today.toLocaleDateString("fr-FR", options);
      }

      doc.text(
        headerX,

        22,

        this.$t("emploi.pdfImprime", { date: formattedDate }),

        { align: headerAlign }
      );

      doc.setTextColor(0);

      doc.setFontSize(10);
      const schoolTitle = getFullSchoolName(schoolDetails, lang == "ar" ? "ArabicName" : "name");

      const schoolWidth = doc.getTextWidth(schoolTitle);

      // Center school title for both languages
      doc.text(pdfWidth / 2 - schoolWidth / 2, 14, schoolTitle);

      doc.setFontSize(12);

      let title = this.$t("emploi.pdfEmploi", { className });
      if (printedWeekType === "A" || printedWeekType === "B") {
        const weekTypeLabel =
          printedWeekType === "A"
            ? this.$t("emploi.weekA")
            : this.$t("emploi.weekB");
        title = `${title} - ${weekTypeLabel}`;
      }

      const width = doc.getTextWidth(title);

      // Center schedule title for both languages
      doc.text(pdfWidth / 2 - width / 2, 22, title);

      doc.setFont("Amiri");

      const times = [
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
      ];

      // Regular sessions always print; A/B sessions only for the printed week type
      const shouldDisplaySchedule = (sched) => {
        if (!sched.week || (sched.week !== "A" && sched.week !== "B")) {
          return true;
        }
        if (!printedWeekType) {
          return true;
        }
        return sched.week === printedWeekType;
      };

      const array = [];

      const rowsCount = (times.length - 1) * 4;

      const cellToDelete = {};

      let position = 0;

      for (let i = 0; i < rowsCount; i++) {
        array[i] = new Array(7).fill(null);
      }

      for (let i = 0; i < times.length - 1; i++) {
        // Use consistent time format for both languages

        let currentTime = times[i] + " - " + times[i + 1];

        const timeColumnIndex = lang === "ar" ? 6 : 0;

        array[i * 4][timeColumnIndex] = {
          content: currentTime,

          rowSpan: 4,

          styles: { halign: "center", valign: "middle" },
        };

        for (let t = 1; t < 4; t++)
          array[i * 4 + t][timeColumnIndex] = cellToDelete;
      }

      // Helper function to process sessions for a specific time slot
      const getGroupKey = (sched) => {
        if (!sched.group) return "";
        if (typeof sched.group === "object") {
          return String(sched.group.name || sched.group._id || "");
        }
        return String(sched.group);
      };

      const getSessionLabel = (sched) =>
        sched.name ||
        sched.subject?.name ||
        sched.moduleGeneral?.name ||
        "";

      const placeCell = (rowIndex, colIndex, cellValue) => {
        const existing = array[rowIndex]?.[colIndex];
        if (
          existing &&
          existing !== cellToDelete &&
          existing !== null &&
          (existing._time || existing._name || existing._diagonalSplit)
        ) {
          // Avoid stacking text on top of an already filled slot
          return false;
        }
        array[rowIndex][colIndex] = cellValue;
        const span = cellValue.rowSpan || 1;
        for (let t = 1; t < span; t++) {
          if (array[rowIndex + t]) {
            array[rowIndex + t][colIndex] = cellToDelete;
          }
        }
        return true;
      };

      const processTimeSlot = (timeSlot, currentPosition) => {
        let schedules = dataToUse.filter(
          (el) =>
            matchesTimeSlot(el.time, timeSlot) && shouldDisplaySchedule(el)
        );

        // One row per session id (API may return duplicates across the fetch window)
        const seenIds = new Set();
        schedules = schedules.filter((el) => {
          const key = el._id ? String(el._id) : `${el.day}_${el.time}_${getGroupKey(el)}`;
          if (seenIds.has(key)) return false;
          seenIds.add(key);
          return true;
        });

        const sessionsByDay = {};

        schedules.forEach((sched) => {
          let dayNumber;
          if (sched.day instanceof Date || typeof sched.day === "string") {
            const sessionMoment = moment(sched.day);
            if (!sessionMoment.isValid()) {
              return;
            }
            const dayOfWeek = sessionMoment.day();
            if (dayOfWeek === 0) {
              return;
            }
            dayNumber = dayOfWeek - 1;
          } else if (typeof sched.day === "number") {
            dayNumber = Number(sched.day);
          } else {
            return;
          }

          if (dayNumber < 0 || dayNumber > 5 || isNaN(dayNumber)) {
            return;
          }

          if (!sessionsByDay[dayNumber]) {
            sessionsByDay[dayNumber] = [];
          }
          sessionsByDay[dayNumber].push(sched);
        });

        Object.keys(sessionsByDay).forEach((dayNumber) => {
          const daySessions = sessionsByDay[dayNumber];
          const day =
            lang === "ar" ? 5 - parseInt(dayNumber) : parseInt(dayNumber) + 1;

          // Normalize times so "8:00" and "08:00" count as the same start
          const enriched = daySessions.map((s) => ({
            sched: s,
            pdfTime: normalizeTime(s.time),
            pdfDuration: Number(s.duration) || 60,
          }));

          const uniqueStarts = new Set(enriched.map((s) => s.pdfTime));
          const uniqueGroups = new Set(
            enriched.map((s) => getGroupKey(s.sched)).filter(Boolean)
          );
          const uniqueWeeks = new Set(
            enriched
              .map((s) => s.sched.week)
              .filter((w) => w === "A" || w === "B")
          );
          const uniqueDurations = new Set(enriched.map((s) => s.pdfDuration));

          const hasMultipleGroups = uniqueGroups.size > 1;
          const hasMultipleWeeks = uniqueWeeks.size > 1;
          const hasSameStartDifferentDuration =
            enriched.length > 1 &&
            uniqueStarts.size === 1 &&
            uniqueDurations.size > 1;
          const needsSplit =
            enriched.length > 1 &&
            (hasMultipleGroups ||
              hasMultipleWeeks ||
              hasSameStartDifferentDuration ||
              uniqueStarts.size === 1);

          if (needsSplit && uniqueStarts.size === 1) {
            const commonDuration = Math.min(
              ...enriched.map((s) => s.pdfDuration)
            );
            const longerList = enriched.filter(
              (s) => s.pdfDuration > commonDuration
            );

            // Stable left/right: group number ascending, else duration ascending
            const ordered = [...enriched].sort((a, b) => {
              const ga = parseInt(String(getGroupKey(a.sched)).replace(/\D/g, ""), 10);
              const gb = parseInt(String(getGroupKey(b.sched)).replace(/\D/g, ""), 10);
              if (!isNaN(ga) && !isNaN(gb) && ga !== gb) return ga - gb;
              return a.pdfDuration - b.pdfDuration;
            });
            const leftSession = ordered[0].sched;
            const rightSession = ordered[1] ? ordered[1].sched : null;

            const sharedRowSpan = Math.max(1, Math.ceil(commonDuration / 15));
            const longerSessions = longerList.map((s) => s.sched);

            const cellValue = {
              content: "",
              rowSpan: sharedRowSpan,
              _time: normalizeTime(leftSession.time),
              _duration: commonDuration,
              _name: getSessionLabel(leftSession),
              _teacher: "",
              _room: "",
              _group: "",
              _week: "",
              _multipleSessions: true,
              _diagonalSplit: true,
              _leftSession: leftSession,
              _rightSession: rightSession,
              _hasSameStartDifferentDuration:
                hasSameStartDifferentDuration || longerSessions.length > 0,
              _commonDuration: commonDuration,
              _sessionsWithDifferentDurations: longerSessions,
              styles: {
                halign: "center",
                valign: "middle",
                fontSize: 9,
                cellPadding: 1.5,
                minCellHeight: 14,
                font: "Amiri",
              },
            };

            placeCell(currentPosition, day, cellValue);

            longerList.forEach((item) => {
              const remainingMinutes = item.pdfDuration - commonDuration;
              if (remainingMinutes <= 0) return;
              const remainingDurationSlots = Math.ceil(remainingMinutes / 15);
              const extendedPosition =
                currentPosition + Math.ceil(commonDuration / 15);
              const remainderStart = endTime(item.pdfTime, commonDuration);
              const extendedSession = item.sched;

              placeCell(extendedPosition, day, {
                content: "",
                rowSpan: remainingDurationSlots,
                _time: remainderStart,
                _duration: remainingMinutes,
                _name: getSessionLabel(extendedSession),
                _teacher:
                  extendedSession.teacher &&
                  extendedSession.teacher.employee &&
                  !this.selectedClassHideTeacher
                    ? `${extendedSession.teacher.employee.firstName} ${extendedSession.teacher.employee.lastName}`
                    : "",
                _room:
                  extendedSession.room && extendedSession.room.name
                    ? extendedSession.room.name
                    : "",
                _group: getGroupKey(extendedSession),
                _week: extendedSession.week || "",
                _isExtendedSession: true,
                styles: {
                  halign: "center",
                  valign: "middle",
                  fontSize: 9,
                  cellPadding: 1.5,
                  minCellHeight: 14,
                  font: "Amiri",
                },
              });
            });
          } else if (needsSplit && uniqueStarts.size > 1) {
            enriched.forEach((item) => {
              const sched = item.sched;
              const rowSpan = Math.max(1, Math.ceil(item.pdfDuration / 15));
              const teacherName =
                sched.teacher &&
                sched.teacher.employee &&
                !this.selectedClassHideTeacher
                  ? `${sched.teacher.employee.firstName} ${sched.teacher.employee.lastName}`
                  : "";
              placeCell(currentPosition, day, {
                content: "",
                rowSpan,
                _time: item.pdfTime,
                _duration: item.pdfDuration,
                _name: getSessionLabel(sched),
                _teacher: teacherName,
                _room: sched.room && sched.room.name ? sched.room.name : "",
                _group: getGroupKey(sched),
                _week: sched.week || "",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fontSize: 9,
                  cellPadding: 1.5,
                  minCellHeight: 14,
                  font: "Amiri",
                },
              });
            });
          } else {
            enriched.forEach((item) => {
              const sched = item.sched;
              const teacherName =
                sched.teacher &&
                sched.teacher.employee &&
                !this.selectedClassHideTeacher
                  ? `${sched.teacher.employee.firstName} ${sched.teacher.employee.lastName}`
                  : "";
              const rowSpan = Math.max(1, Math.ceil(item.pdfDuration / 15));
              placeCell(currentPosition, day, {
                content: "",
                rowSpan,
                _time: item.pdfTime,
                _duration: item.pdfDuration,
                _name: getSessionLabel(sched),
                _teacher: teacherName,
                _room: sched.room && sched.room.name ? sched.room.name : "",
                _group: getGroupKey(sched),
                _week: sched.week || "",
                styles: {
                  halign: "center",
                  valign: "middle",
                  fontSize: 9,
                  cellPadding: 1.5,
                  minCellHeight: 14,
                  font: "Amiri",
                },
              });
            });
          }
        });
      };

      for (let i = 0; i < times.length - 1; i++) {
        const baseHour = times[i].split(":")[0];

        // H:00
        processTimeSlot(times[i], position);
        position++;

        // H:15
        const time15 = `${baseHour}:15`;
        processTimeSlot(time15, position);
        position++;

        // H:30
        const time30 = `${baseHour}:30`;
        processTimeSlot(time30, position);
        position++;

        // H:45
        const time45 = `${baseHour}:45`;
        processTimeSlot(time45, position);
        position++;
      }

      for (let row = 0; row < rowsCount; row++) {
        array[row] = array[row].filter((cell) => cell !== cellToDelete);
      } // Translation keys for week and group labels

      const weekLabel = this.$t("schedule.week");

      const groupLabel = this.$t("schedule.group");

      // Side-by-side split for overlapping sessions (groups / A-B / different durations).
      // Diagonal layout spilled text into the header and the next hour cell.
      const drawDiagonalSplitCell = (
        data,
        doc,
        _startY,
        _cellCenter,
        _isUnderOneHour,
        compactMode
      ) => {
        const cell = data.cell;
        const leftSession = data.cell.raw._leftSession;
        const rightSession = data.cell.raw._rightSession;
        const pad = 0.8;
        const halfW = cell.width / 2;

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.4);
        doc.line(
          cell.x + halfW,
          cell.y,
          cell.x + halfW,
          cell.y + cell.height
        );

        const leftBox = {
          x: cell.x + pad,
          y: cell.y + pad,
          w: halfW - pad * 2,
          h: cell.height - pad * 2,
        };
        const rightBox = {
          x: cell.x + halfW + pad,
          y: cell.y + pad,
          w: halfW - pad * 2,
          h: cell.height - pad * 2,
        };

        // Always sort by duration for label accuracy on remainder blocks
        const pair = [leftSession, rightSession].filter(Boolean);
        const byDuration = [...pair].sort(
          (a, b) => (Number(a.duration) || 0) - (Number(b.duration) || 0)
        );

        // Display order: prefer group number ascending (G1 left, G2 right)
        const byGroup = [...pair].sort((a, b) => {
          const ga = parseInt(String(getGroupKey(a)).replace(/\D/g, ""), 10);
          const gb = parseInt(String(getGroupKey(b)).replace(/\D/g, ""), 10);
          if (!isNaN(ga) && !isNaN(gb) && ga !== gb) return ga - gb;
          return 0;
        });

        const displayLeft = byGroup[0] || byDuration[0];
        const displayRight =
          byGroup.find((s) => s !== displayLeft) || byDuration[1];

        drawSessionInBox(doc, displayLeft, leftBox, compactMode);
        drawSessionInBox(doc, displayRight, rightBox, compactMode);
      };

      // Draw one session clipped inside a box (used by side-by-side split)
      const drawSessionInBox = (doc, session, box, compactMode) => {
        if (!session || !box || box.w < 2 || box.h < 2) return;

        const sessionName = getSessionLabel(session);
        const teacherName =
          session.teacher &&
          session.teacher.employee &&
          !this.selectedClassHideTeacher
            ? `${session.teacher.employee.firstName} ${session.teacher.employee.lastName}`
            : "";
        const roomText =
          session.room && session.room.name ? session.room.name : "";
        const week = session.week || "";
        const groupKey = getGroupKey(session);
        const start = normalizeTime(session.time);
        const durationMinutes = Number(session.duration) || 60;
        const timeRange = `${start}-${endTime(start, durationMinutes)}`;

        const centerX = box.x + box.w / 2;
        const topY = box.y + 2.2;
        const bottomY = box.y + box.h - 1.2;

        doc.setFont("Amiri", "normal");
        let teacherSize = teacherName.length > 14 ? 5 : teacherName.length > 10 ? 6 : 7;
        teacherSize = Math.min(teacherSize, Math.max(4, box.h * 0.35));
        doc.setFontSize(teacherSize);
        if (teacherName) {
          const teacherLines = doc.splitTextToSize(teacherName, box.w - 1);
          doc.text(teacherLines[0], box.x + 0.5, topY, { align: "left" });
        }

        if (roomText) {
          doc.setFontSize(5);
          doc.text(roomText, box.x + box.w - 0.5, topY, { align: "right" });
        }

        doc.setFont("Amiri", "Bold");
        let titleSize = getSessionTitleFontSize(
          sessionName,
          box.w,
          true,
          compactMode
        );
        titleSize = Math.max(4, Math.min(titleSize, 8));
        doc.setFontSize(titleSize);
        const nameLines = doc
          .splitTextToSize(sessionName || "", box.w - 1)
          .slice(0, box.h < 10 ? 1 : 2);
        const titleStartY = topY + (teacherName ? 3.2 : 1.5);
        nameLines.forEach((line, index) => {
          const y = titleStartY + index * (titleSize * 0.45 + 1.2);
          if (y < bottomY - 3) {
            doc.text(line, centerX, y, { align: "center" });
          }
        });

        doc.setFont("Amiri", "Bold");
        doc.setFontSize(5);
        doc.text(timeRange, box.x + box.w - 0.5, bottomY, { align: "right" });

        const metaParts = [];
        if (groupKey) {
          const groupNumber = String(groupKey).replace(/\D/g, "");
          metaParts.push(
            lang === "ar"
              ? `م${groupNumber || groupKey.substring(0, 2)}`
              : `G${groupNumber || groupKey.substring(0, 2)}`
          );
        }
        if (week === "A" || week === "B") {
          metaParts.push(lang === "ar" ? `${week}أ` : `W${week}`);
        }
        if (metaParts.length) {
          doc.setFont("Amiri", "normal");
          doc.setFontSize(5);
          doc.text(metaParts.join(" "), box.x + 0.5, bottomY, {
            align: "left",
          });
        }
      };

      // Compute dynamic sizes to fit exactly one page with small padding

      const pageWidth = doc.internal.pageSize.getWidth();

      const pageHeight = doc.internal.pageSize.getHeight();

      const bottomMargin = 0;

      const startY = 26; // anchor table near the header on page 1 - reduced top margin

      const leftRightPadding = 2; // small padding on both sides - reduced from 8

      const usableWidth = pageWidth - leftRightPadding * 2;

      const timeColWidth = 20; // tighter to gain vertical fit

      const dayCols = 6;

      const dayColWidth = (usableWidth - timeColWidth) / dayCols; // Compute dynamic row height to force one-page table

      const finalRowHeight = 3.993;

      const compactMode = false;
      const isVeryComplex = false;

      doc.autoTable({
        columns:
          lang == "ar"
            ? [
                this.$t("schedule.saturday"),

                this.$t("schedule.friday"),

                this.$t("schedule.thursday"),

                this.$t("schedule.wednesday"),

                this.$t("schedule.tuesday"),

                this.$t("schedule.monday"),

                this.$t("schedule.time"),
              ]
            : [
                this.$t("schedule.time"),

                this.$t("schedule.monday"),

                this.$t("schedule.tuesday"),

                this.$t("schedule.wednesday"),

                this.$t("schedule.thursday"),

                this.$t("schedule.friday"),

                this.$t("schedule.saturday"),
              ],

        body: array,

        theme: "plain", // Clean base

        tableWidth: usableWidth,

        startY: startY,

        pageBreak: "auto",

        styles: {
          font: "Amiri",

          fontSize: isVeryComplex ? 8 : 9, // Increased font size for better readability

          lineWidth: 0,

          lineColor: [255, 255, 255],

          cellPadding: 1.5, // Increased padding for better spacing

          halign: "center",

          valign: "middle",
        }, // Keep small padding while using full width

        margin: {
          top: 0,

          left: leftRightPadding,

          right: leftRightPadding,

          bottom: bottomMargin,
        },

        headStyles: {
          valign: "middle",

          halign: "center",

          fontSize: lang == "ar" ? 8 : 8, // Increased header font size

          fontStyle: "bold",

          fillColor: [173, 216, 230], // Blue header background

          textColor: [50, 50, 50], // White text

          lineWidth: 0.3, // Add header borders

          lineColor: [0, 0, 0], // Black borders

          cellPadding: 1.5,
        },

        columnStyles:
          lang === "ar"
            ? {
                0: { cellWidth: dayColWidth },

                1: { cellWidth: dayColWidth },

                2: { cellWidth: dayColWidth },

                3: { cellWidth: dayColWidth },

                4: { cellWidth: dayColWidth },

                5: { cellWidth: dayColWidth },

                6: {
                  // Time column styling for Arabic (rightmost column)

                  fontStyle: "bold",

                  fillColor: [173, 216, 230], // Blue background to match header

                  textColor: [50, 50, 50], // White text

                  halign: "center",

                  cellWidth: timeColWidth,

                  lineWidth: 0.3,

                  lineColor: [0, 0, 0],
                },
              }
            : {
                0: {
                  // Time column styling (left for LTR languages)

                  fontStyle: "bold",

                  fillColor: [173, 216, 230], // Blue background to match header

                  textColor: [50, 50, 50], // White text

                  halign: "center",

                  cellWidth: timeColWidth,

                  lineWidth: 0.3,

                  lineColor: [0, 0, 0],
                },

                1: { cellWidth: dayColWidth },

                2: { cellWidth: dayColWidth },

                3: { cellWidth: dayColWidth },

                4: { cellWidth: dayColWidth },

                5: { cellWidth: dayColWidth },

                6: { cellWidth: dayColWidth },
              },

        bodyStyles: {
          fontSize: 9, // Increased font size for better readability

          cellPadding: 0.1, // Increased padding for better spacing

          // minCellHeight: finalRowHeight, // Use final calculated height
          maxCellHeight: finalRowHeight,
          lineWidth: 0.1, // Thinner borders for better space usage

          lineColor: [0, 0, 0], // Black day dividers
        },

        willDrawCell: (data) => {
          if (data.section != "head") {
            // Dynamic row height to fit everything on one page

            data.row.height = finalRowHeight;

            data.cell.contentHeight = finalRowHeight;

            data.cellHeight = finalRowHeight;

            data.cell.height = finalRowHeight * (data.cell.rowSpan || 1);
          } // Remove all borders from all cells

          if (data.section === "body") {
            data.cell.styles.lineWidth = 0;

            data.cell.styles.lineColor = [255, 255, 255];
          }
        }, // Custom drawing for cleaner borders - only hour and day separators

        didDrawCell: function (data) {
          // Draw day dividers
          if (data.section === "body" && data.column.index > 0) {
            const doc = data.doc;
            const cell = data.cell;

            // Draw vertical line between days
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.5); // Thicker day dividers
            doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
          }

          // Draw hour dividers (horizontal lines between time slots)
          if (
            data.section === "body" &&
            data.row.index > 0 &&
            data.row.index % 4 === 0
          ) {
            const doc = data.doc;
            const cell = data.cell;

            // Draw horizontal line between hour blocks
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.5); // Thicker hour dividers
            doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
          }

          // Draw borders for diagonal split cells to ensure proper separation
          if (
            data.section === "body" &&
            data.cell.raw &&
            data.cell.raw._diagonalSplit
          ) {
            const doc = data.doc;
            const cell = data.cell;

            // Draw complete border around diagonal split cells
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.3);
            doc.rect(cell.x, cell.y, cell.width, cell.height);
          }

          // Draw borders for regular cells that are adjacent to diagonal split cells
          if (
            data.section === "body" &&
            data.cell.raw &&
            !data.cell.raw._diagonalSplit
          ) {
            const doc = data.doc;
            const cell = data.cell;

            // Check if this cell has content and needs borders
            if (data.cell.raw._time || data.cell.raw._name) {
              // Draw complete border around regular cells with content
              doc.setDrawColor(0, 0, 0);
              doc.setLineWidth(0.3);
              doc.rect(cell.x, cell.y, cell.width, cell.height);
            }
          }

          // Handle session content drawing
          if (data.cell.raw && data.cell.raw._time) {
            const startY = data.cell.y + 2;

            const cellCenter = data.cell.x + data.cell.width / 2;

            const sessionRowSpan = data.cell.raw.rowSpan || 1;

            const isUnderOneHour = sessionRowSpan < 4; // Less than 1 hour (4 slots × 15min = 60min)

            data.cell.text = [];

            // Handle diagonal split display for multiple sessions with different weeks
            // or sessions with same start time but different durations
            if (
              data.cell.raw._diagonalSplit &&
              data.cell.raw._leftSession &&
              (data.cell.raw._rightSession ||
                data.cell.raw._hasSameStartDifferentDuration)
            ) {
              drawDiagonalSplitCell(
                data,
                doc,
                startY,
                cellCenter,
                isUnderOneHour,
                compactMode
              );
              return;
            }

            // Handle extended sessions (sessions that continue beyond common duration)
            if (data.cell.raw._isExtendedSession) {
              // Extended sessions are displayed normally without diagonal split
              // The diagonal split is only shown in the common duration area
              // This cell represents the continuation of a longer session
              // Continue with normal processing below
            }

            if (data.cell.raw.rowSpan < 4) { // Less than 1 hour (60 minutes)
              const roomText = data.cell.raw._room || "";

              const sessionStartTime = data.cell.raw._time || "";

              const cellBottom = data.cell.y + data.cell.height; // Top-left corner: Teacher name

              if (data.cell.raw._teacher) {
                doc.setFont("Amiri", "normal");

                // Adjust font sizes for complex timetables
                let baseTeacherSize = isUnderOneHour
                  ? compactMode
                    ? 8
                    : 9
                  : compactMode
                  ? 10
                  : 11;

                // Reduce size if teacher name is longer than 10 characters
                if (
                  data.cell.raw._teacher &&
                  data.cell.raw._teacher.length > 10
                ) {
                  baseTeacherSize = Math.max(baseTeacherSize - 2, 4);
                }

                const teacherSize = isVeryComplex
                  ? Math.max(3, baseTeacherSize - 1)
                  : baseTeacherSize;

                doc.setFontSize(teacherSize);

                doc.text(
                  doc.splitTextToSize(
                    data.cell.raw._teacher,
                    data.cell.width - 4
                  )[0],
                  data.cell.x + 1,
                  startY + 1,
                  { align: "left" }
                );
              } // Center: Session title (bold, vertically centered)

              doc.setFont("Amiri", "Bold");

              const titleSize = getSessionTitleFontSize(
                data.cell.raw._name,
                data.cell.width,
                isUnderOneHour,
                compactMode
              );

              doc.setFontSize(titleSize);

              // Align title near the top of the slot (not vertical center) so long
              // sessions (e.g. 12:00–14:00) are not perceived as sitting in mid-block.
              const titleY = data.cell.raw._teacher
                ? startY + 5
                : startY + 3;

              if (doc.getTextWidth(data.cell.raw._name) > data.cell.width - 4) {
                const nameLines = doc.splitTextToSize(
                  data.cell.raw._name,

                  data.cell.width - 4
                );

                nameLines.forEach((line, index) => {
                  doc.text(line, cellCenter, titleY + index * 3, {
                    align: "center",
                  });
                });
              } else {
                doc.text(data.cell.raw._name, cellCenter, titleY, {
                  align: "center",
                });
              } // Top-right corner: Room number

              if (roomText) {
                doc.setFont("Amiri", "normal");

                const roomSize = isUnderOneHour
                  ? compactMode
                    ? 7
                    : 8
                  : compactMode
                  ? 6
                  : 7;

                doc.setFontSize(roomSize);

                doc.text(
                  roomText,

                  data.cell.x + data.cell.width - 1,

                  startY + 1,

                  {
                    align: "right",
                  }
                );
              } // Bottom-right: Start time and Week/Group info

              if (sessionStartTime) {
                doc.setFont("Amiri", "Bold");

                const timeSize = isUnderOneHour
                  ? compactMode
                    ? 6
                    : 7
                  : compactMode
                  ? 8
                  : 9;

                doc.setFontSize(timeSize);

                // Calculate end time and format as start-end range
                // Use actual duration stored in cell data (in minutes)
                const durationMinutes = data.cell.raw._duration || (data.cell.raw.rowSpan * 15); // Fallback to rowSpan * 15 for backward compatibility
                const endTimeValue = endTime(
                  sessionStartTime,
                  durationMinutes
                );
                const timeRange = `${sessionStartTime}-${endTimeValue}`;

                // Shrink so the full range stays inside the day column
                let fitTimeSize = timeSize;
                while (
                  fitTimeSize > 4 &&
                  doc.getTextWidth(timeRange) > data.cell.width - 2
                ) {
                  fitTimeSize -= 0.5;
                  doc.setFontSize(fitTimeSize);
                }

                doc.text(
                  timeRange,

                  data.cell.x + data.cell.width - 1,

                  cellBottom - 1,

                  { align: "right" }
                );
              } // Bottom-left: Week and group info

              if (!compactMode) {
                const metaParts = [];

                // Handle multiple sessions with different weeks/groups
                if (
                  data.cell.raw._multipleSessions &&
                  data.cell.raw._weekGroupInfo
                ) {
                  // Display each week/group combination on a separate line
                  data.cell.raw._weekGroupInfo.forEach((info, index) => {
                    metaParts.push(`${index + 1}. ${info}`);
                  });
                } else {
                  // Single session - display normally
                  if (data.cell.raw._week) {
                    const weekDisplay =
                      data.cell.raw._week === "A"
                        ? "أ"
                        : data.cell.raw._week === "B"
                        ? "ب"
                        : data.cell.raw._week;
                    metaParts.push(`${weekLabel} ${weekDisplay}`);
                  }

                  if (data.cell.raw._group)
                    metaParts.push(`● ${groupLabel}: ${data.cell.raw._group}`);
                }

                if (metaParts.length > 0) {
                  doc.setFont("Amiri", "normal");

                  const metaSize = isUnderOneHour
                    ? compactMode
                      ? 6
                      : 7
                    : compactMode
                    ? 7
                    : 8;

                  doc.setFontSize(metaSize);

                  // For multiple sessions, display each on a separate line
                  if (
                    data.cell.raw._multipleSessions &&
                    data.cell.raw._weekGroupInfo
                  ) {
                    const lineHeight = 2.5;
                    const startY = cellBottom - metaParts.length * lineHeight;

                    metaParts.forEach((info, index) => {
                      const metaY = startY + index * lineHeight;
                      const metaX = data.cell.x + 1;

                      doc.text(info, metaX, metaY, {
                        align: "left",
                      });
                    });
                  } else {
                    // Single session - display on one line
                    const metaText = metaParts.join("  ·  ");
                    const metaY = cellBottom - 1;
                    const metaX = data.cell.x + 1;

                    doc.text(metaText, metaX, metaY, {
                      align: "left",
                    });
                  }
                }
              }
            } else {
              // rowSpan >= 4 (e.g., 1 hour and longer - 4 slots × 15min = 60min)

              const roomText = data.cell.raw._room || "";

              const sessionStartTime = data.cell.raw._time || "";

              const cellBottom = data.cell.y + data.cell.height; // Top-left corner: Teacher name

              if (data.cell.raw._teacher) {
                doc.setFont("Amiri", "normal");

                let baseTeacherSize = isUnderOneHour
                  ? compactMode
                    ? 8
                    : 9
                  : compactMode
                  ? 10
                  : 11;

                // Reduce size if teacher name is longer than 10 characters
                if (
                  data.cell.raw._teacher &&
                  data.cell.raw._teacher.length > 10
                ) {
                  baseTeacherSize = Math.max(baseTeacherSize - 2, 4);
                }

                const teacherSize = baseTeacherSize;

                doc.setFontSize(teacherSize);

                doc.text(
                  doc.splitTextToSize(
                    data.cell.raw._teacher,
                    data.cell.width - 4
                  )[0],
                  data.cell.x + 1,
                  startY + 1,
                  { align: "left" }
                );
              } // Session title near top of slot (not vertically centered)

              doc.setFont("Amiri", "Bold");

              const titleSize = getSessionTitleFontSize(
                data.cell.raw._name,
                data.cell.width,
                isUnderOneHour,
                compactMode
              );

              doc.setFontSize(titleSize);

              const titleY = data.cell.raw._teacher
                ? startY + 6
                : startY + 4;

              if (doc.getTextWidth(data.cell.raw._name) > data.cell.width - 4) {
                const nameLines = doc.splitTextToSize(
                  data.cell.raw._name,

                  data.cell.width - 4
                );

                const lineSpacing = 3.5;

                nameLines.forEach((line, index) => {
                  doc.text(line, cellCenter, titleY + index * lineSpacing, {
                    align: "center",
                  });
                });
              } else {
                doc.text(data.cell.raw._name, cellCenter, titleY, {
                  align: "center",
                });
              } // Top-right corner: Room number

              if (roomText) {
                doc.setFont("Amiri", "normal");

                const roomSize = isUnderOneHour
                  ? compactMode
                    ? 4
                    : 5
                  : compactMode
                  ? 6
                  : 7;

                doc.setFontSize(roomSize);

                doc.text(
                  roomText,

                  data.cell.x + data.cell.width - 1,

                  startY + 1,

                  {
                    align: "right",
                  }
                );
              } // Bottom-right: Start time and Week/Group info

              if (sessionStartTime) {
                doc.setFont("Amiri", "Bold");

                const timeSize = isUnderOneHour
                  ? compactMode
                    ? 6
                    : 7
                  : compactMode
                  ? 8
                  : 9;

                doc.setFontSize(timeSize);

                // Calculate end time and format as start-end range
                // Use actual duration stored in cell data (in minutes)
                const durationMinutes = data.cell.raw._duration || (data.cell.raw.rowSpan * 15); // Fallback to rowSpan * 15 for backward compatibility
                const endTimeValue = endTime(
                  sessionStartTime,
                  durationMinutes
                );
                const timeRange = `${sessionStartTime}-${endTimeValue}`;

                // Shrink so the full range stays inside the day column
                let fitTimeSize = timeSize;
                while (
                  fitTimeSize > 4 &&
                  doc.getTextWidth(timeRange) > data.cell.width - 2
                ) {
                  fitTimeSize -= 0.5;
                  doc.setFontSize(fitTimeSize);
                }

                doc.text(
                  timeRange,

                  data.cell.x + data.cell.width - 1,

                  cellBottom - 1,

                  { align: "right" }
                );
              } // Bottom-left: Week and group info

              if (!compactMode) {
                const metaParts = [];

                // Handle multiple sessions with different weeks/groups
                if (
                  data.cell.raw._multipleSessions &&
                  data.cell.raw._weekGroupInfo
                ) {
                  // Display each week/group combination on a separate line
                  data.cell.raw._weekGroupInfo.forEach((info, index) => {
                    metaParts.push(`${index + 1}. ${info}`);
                  });
                } else {
                  // Single session - display normally
                  if (data.cell.raw._week) {
                    const weekDisplay =
                      data.cell.raw._week === "A"
                        ? "أ"
                        : data.cell.raw._week === "B"
                        ? "ب"
                        : data.cell.raw._week;
                    metaParts.push(`${weekLabel} ${weekDisplay}`);
                  }

                  if (data.cell.raw._group)
                    metaParts.push(`● ${groupLabel}: ${data.cell.raw._group}`);
                }

                if (metaParts.length > 0) {
                  doc.setFont("Amiri", "normal");

                  const metaSize = isUnderOneHour
                    ? compactMode
                      ? 6
                      : 7
                    : compactMode
                    ? 7
                    : 8;

                  doc.setFontSize(metaSize);

                  // For multiple sessions, display each on a separate line
                  if (
                    data.cell.raw._multipleSessions &&
                    data.cell.raw._weekGroupInfo
                  ) {
                    const lineHeight = 2.5;
                    const startY = cellBottom - metaParts.length * lineHeight;

                    metaParts.forEach((info, index) => {
                      const metaY = startY + index * lineHeight;
                      const metaX = data.cell.x + 1;

                      doc.text(info, metaX, metaY, {
                        align: "left",
                      });
                    });
                  } else {
                    // Single session - display on one line
                    const metaText = metaParts.join("  ·  ");
                    const metaY = cellBottom - 1;
                    const metaX = data.cell.x + 1;

                    doc.text(metaText, metaX, metaY, {
                      align: "left",
                    });
                  }
                }
              }
            }
          } // Draw header borders

          if (data.section === "head") {
            const doc = data.doc;

            const cell = data.cell;

            const borderWeight = 0.3; // Draw complete borders around header cells

            doc.setDrawColor(0, 0, 0);

            doc.setLineWidth(borderWeight);

            doc.rect(cell.x, cell.y, cell.width, cell.height);
          } // Draw all borders with same weight

          if (data.section === "body") {
            const doc = data.doc;

            const cell = data.cell;

            const borderWeight = 0.3; // Same weight for all borders // Draw vertical dividers (between time column and days, and between day columns)

            if (data.column.index >= 0 && data.column.index < 6) {
              doc.setDrawColor(0, 0, 0); // Black for all borders

              doc.setLineWidth(borderWeight);

              doc.line(
                cell.x + cell.width,

                cell.y,

                cell.x + cell.width,

                cell.y + cell.height
              );
            } // Draw outer borders // Left border (time column for French, first day column for Arabic)

            if (data.column.index === 0) {
              doc.setDrawColor(0, 0, 0);

              doc.setLineWidth(borderWeight);

              doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
            } // Right border (last day column for French, time column for Arabic)

            if (data.column.index === 6) {
              doc.setDrawColor(0, 0, 0);

              doc.setLineWidth(borderWeight);

              doc.line(
                cell.x + cell.width,

                cell.y,

                cell.x + cell.width,

                cell.y + cell.height
              );
            } // Top border (first row)

            if (data.row.index === 0) {
              doc.setDrawColor(0, 0, 0);

              doc.setLineWidth(borderWeight);

              doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
            } // Bottom border (last row)

            if (data.row.index === array.length - 1) {
              doc.setDrawColor(0, 0, 0);

              doc.setLineWidth(borderWeight);

              doc.line(
                cell.x,

                cell.y + cell.height,

                cell.x + cell.width,

                cell.y + cell.height
              );
            } // Draw hour dividers (horizontal lines between hours) // Only draw for the first row of each hour block (every 4 rows = 1 hour)

            const isFirstRowOfHour = data.row.index % 4 === 0;

            if (isFirstRowOfHour && data.row.index > 0) {
              doc.setDrawColor(0, 0, 0); // Black for all borders

              doc.setLineWidth(borderWeight); // Always draw hour divider in time column (left for LTR languages, right for Arabic)

              const isTimeColumn =
                lang === "ar"
                  ? data.column.index === 6
                  : data.column.index === 0;

              if (isTimeColumn) {
                doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
              } else {
                // For day columns, always draw hour divider

                // The session borders will be drawn on top, creating the visual effect

                doc.line(cell.x, cell.y, cell.x + cell.width, cell.y);
              }
            } // Draw complete borders around time column cells (left for LTR languages, right for Arabic)

            const isTimeColumn =
              lang === "ar" ? data.column.index === 6 : data.column.index === 0;

            if (isTimeColumn) {
              doc.setDrawColor(0, 0, 0);

              doc.setLineWidth(borderWeight);

              doc.rect(cell.x, cell.y, cell.width, cell.height);
            }
          } // Draw borders only around actual sessions (after dividers)

          if (data.section === "body" && data.cell.raw && data.cell.raw._time) {
            const doc = data.doc;

            const cell = data.cell;

            const borderWeight = 0.3; // Same weight for all borders // Draw border around the session cell

            doc.setDrawColor(0, 0, 0);

            doc.setLineWidth(borderWeight); // Draw rectangle around the session

            doc.rect(cell.x, cell.y, cell.width, cell.height);
          }
        },

        didParseCell: function (data) {
          // Style time column cells (left for LTR languages, right for Arabic)

          const isTimeColumn =
            lang === "ar" ? data.column.index === 6 : data.column.index === 0;

          if (isTimeColumn) {
            data.cell.styles.fontStyle = "bold";

            data.cell.styles.fillColor = [173, 216, 230]; // Blue background to match header

            data.cell.styles.textColor = [50, 50, 50]; // White text

            data.cell.styles.halign = "center";

            data.cell.styles.lineWidth = 0.3; // Add borders for time column

            data.cell.styles.lineColor = [0, 0, 0]; // Black borders
          } // Style schedule cells - no borders at all

          if (data.section === "body" && data.column.index > 0) {
            data.cell.styles.fontSize = 8;

            data.cell.styles.cellPadding = 1.5;

            data.cell.styles.lineWidth = 0; // No borders

            data.cell.styles.lineColor = [255, 255, 255];
          } // Remove green colors and use neutral colors

          if (
            data.cell.styles.fillColor &&
            data.cell.styles.fillColor[0] === 65 &&
            data.cell.styles.fillColor[1] === 184 &&
            data.cell.styles.fillColor[2] === 131
          ) {
            data.cell.styles.fillColor = [248, 248, 248];
          }
        },
      });

      // Restore original locale
      this.$i18n.locale = originalLocale;

      this.loadingPdf = false;

      doc.save(title + ".pdf");
    },
    resetSchedules() {
      this.resetSchedulesLoading = true;
      apiClient
        .post("/smartSchedule/schedJobParam/unmigrate/", {})
        .then((res) => {
          if (res.data.type == "success")
            this.$message.success(this.$t("smartSchedule." + res.data.message));
          else if (res.data.type == "warning")
            this.$message.warning(this.$t("smartSchedule." + res.data.message));
          else if (res.data.type == "error")
            this.$message.error(this.$t("smartSchedule." + res.data.message));

          if (res.data.type == "success")
            setTimeout(() => {
              window.location.reload();
            }, 100);
        })
        .catch((err) => {
          this.$message.error(this.$t("error.error"));
        })
        .finally(() => {
          this.resetSchedulesLoading = false;
        });
    },
    // Force refresh calendar data
    refreshCalendar() {
      if (this.$refs.calendar && this.$refs.calendar.getApi) {
        // Clear existing events and refetch
        this.$refs.calendar.getApi().removeAllEvents();
        this.$refs.calendar.getApi().refetchEvents();

        // Fallback: ensure loading state is turned off after a reasonable timeout
        setTimeout(() => {
          this.calendarLoading = false;
        }, 2000);
      }
    },
    // Fetch schedule data from server
    async fetchScheduleData(customStartDate = null, customEndDate = null) {
      if (!this.selectedClasse) return null;

      try {
        let startDate, endDate;

        if (customStartDate && customEndDate) {
          startDate = customStartDate;
          endDate = customEndDate;
        } else {
          startDate = this.selectedWeekStart
            ? new Date(this.selectedWeekStart)
            : new Date();
          startDate.setHours(0, 0, 0, 0);

          endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + 12);
          endDate.setHours(23, 59, 59, 999);
        }

        const response = await apiClient.post("/schedules/classroom/" + this.selectedClasse, {
          startDate: startDate,
          endDate: endDate,
        });
        console.log(response);
        const data = response.data.schedules.map((sched) => {
          if (sched.moduleGeneral && sched.moduleGeneral._id) {
            sched.subject = sched.moduleGeneral;
          }
          return sched;
        });
        console.log(data);
        return data;
      } catch (error) {
        this.$message.error(this.$t("error.error"));
        return null;
      }
    },
    async reloadScheduleData() {
      if (!this.selectedClasse) return;

      this.loading = true;
      this.calendarLoading = true;

      const data = await this.fetchScheduleData();

      if (data) {
        this.data = data.filter(
          (sched) => sched.classeRoom._id == this.selectedClasse
        );

        // Get hideTeacher value from first session's classroom data
        // Only update if we haven't just updated it (to avoid overriding user changes)
        if (
          this.data.length > 0 &&
          this.data[0].classeRoom &&
          !this.justUpdatedHideTeacher
        ) {
          this.selectedClassHideTeacher =
            this.data[0].classeRoom.hideTeacher || false;
        }
        // Reset the flag after processing
        this.justUpdatedHideTeacher = false;

        this.dataAllClasses = data;
        this.loading = false;
        console.log(this.data);
        this.refreshCalendar();
      } else {
        this.loading = false;
        this.calendarLoading = false;
      }
    },
    // Disable past dates in date picker
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    // Handle date selection in calendar
    onDateSelect(date) {
      this.customEndDate = date;
    },
    // Handle calendar confirmation
    async handleCalendarConfirm() {
      // If custom duration is selected, validate date
      if (this.durationOption === "custom" && !this.customEndDate) {
        this.$message.error(this.$t("emploi.selectEndDate"));
        return;
      }
      this.showCalendarModal = false;
      this.updateLoading = true;
      try {
        await this.performBulkUpdate(true);
      } finally {
        this.updateLoading = false;
      }
    },
    // Perform single session update
    async performSingleUpdate() {
      if (!this.pendingUpdateData) {
        this.revertPendingDrag();
        this.$message.error(this.$t("error.noDataToUpdate"));
        return;
      }

      this.updateLoading = true;
      try {
        await this.performBulkUpdate(false);
      } finally {
        this.updateLoading = false;
      }
    },
    // Perform bulk update (all sessions)
    async performBulkUpdate(updateAll) {
      if (!this.pendingUpdateData) {
        this.$message.error(this.$t("error.noDataToUpdate"));
        return;
      }

      const updateData = {
        updateAll: updateAll,
        updateData: this.pendingUpdateData,
      };

      // Add end date if updating all sessions with custom date
      if (updateAll && this.durationOption === "custom" && this.customEndDate) {
        updateData.endDate = moment(this.customEndDate).format("YYYY-MM-DD");
      }
      if (updateAll && this.durationOption === "whole-year") {
        updateData.scope = "school-year";
      }

      try {
        const response = await apiClient.patch(
          `/schedules/${this.selectedSchedule._id}/bulk-update`,
          updateData
        );

        this.$message.success(
          this.$t("success.sessionsUpdated", {
            count: Array.isArray(response.data) ? response.data.length : 1,
          })
        );

        // The calendar is rebuilt from the reload below
        this.pendingRevert = null;
        this.pendingUpdateData = null;
        this.customEndDate = null;
        this.onClose();

        // Preserve the current hide teacher toggle state before reloading
        const currentHideTeacherState = this.selectedClassHideTeacher;

        // Reload data from server to ensure consistency
        await this.reloadScheduleData();

        // Restore the hide teacher toggle state after reload
        this.selectedClassHideTeacher = currentHideTeacherState;
      } catch (e) {
        this.revertPendingDrag();
        this.pendingUpdateData = null;
        this.customEndDate = null;

        const errorId = e.response && e.response.data && e.response.data.errorId;
        if (e.response && e.response.status == 400 && [1, 2, 3, 4].includes(Number(errorId))) {
          const conflictDescription = this.formatConflictSessionDescription(
            e.response.data
          );
          const details = e.response.data.details || {};
          const schedule = e.response.data.schedule || {};

          if (e.response.data.errorId == 1) {
            const errorMessage = this.$t("error.classConflictUpdate", {
              className:
                details.className ||
                schedule.classeRoom?.name ||
                "Unknown Class",
            });

            this.$message.error(errorMessage);
            this.submitError = {
              message: errorMessage,
              description: conflictDescription,
              details: details,
            };
          }

          if (e.response.data.errorId == 2) {
            const errorMessage = this.$t("error.teacherConflictUpdate", {
              teacherName:
                details.teacherName ||
                (schedule.teacher && schedule.teacher.employee
                  ? `${schedule.teacher.employee.firstName} ${schedule.teacher.employee.lastName}`
                  : "Unknown Teacher"),
            });

            this.$message.error(errorMessage);
            this.submitError = {
              message: errorMessage,
              description: conflictDescription,
              details: details,
            };
          }

          if (e.response.data.errorId == 3) {
            this.$message.error(this.$t("error.salleIndis"));
            this.submitError = {
              message: this.$t("error.salleIndis"),
              description: this.$t("error.sallePriseEntre", {
                room: schedule.room?.name || "-",
                name: schedule.classeRoom?.name || "-",
                start: schedule.time || "-",
                end: schedule.ends || "-",
              }),
            };
          }

          if (e.response.data.errorId == 4) {
            this.$message.error(this.$t("error.capacite"));
          }
        } else {
          showApiError(this, e);
        }
      }
    },
    // Add Session Modal Methods
    showAddSessionModal() {
      if (!this.selectedClasse) {
        this.$message.error(this.$t("error.selectClasse"));
        return;
      }
      this.addSessionModalVisible = true;
      this.addSessionError = null;

      // Reset form fields
      this.$nextTick(() => {
        this.addSessionForm.resetFields();
        // Explicitly set time field to null to avoid invalid moment warning
        this.addSessionForm.setFieldsValue({
          time: null,
        });
      });

      // Load filtered teachers and rooms for the selected class
      this.loadFilteredTeachersAndRooms();

      // Ensure we have basic data if filtering fails
      if (!this.filtredTeachers || !this.filtredTeachers.disponible) {
        this.filtredTeachers = {
          disponible: this.teachers || [],
          indisponible: [],
        };
      }
      if (!this.filtredRooms || !this.filtredRooms.disponible) {
        this.filtredRooms = {
          disponible: this.rooms || [],
          indisponible: [],
        };
      }
    },
    closeAddSessionModal() {
      this.addSessionModalVisible = false;
      this.addSessionError = null;
      this.addSessionForm.resetFields();
    },
    handleAddSessionSubmit(e) {
      e.preventDefault();
      this.addSessionForm.validateFields((err, values) => {
        if (!err) {
          this.createNewSession(values);
        }
      });
    },
    async createNewSession(formData) {
      this.addSessionLoading = true;
      this.addSessionError = null;

      try {
        // Convert time picker value to time string
        const time = formData.time.format("HH:mm");

        // Duration is already in minutes (1 slot = 1 minute)
        const durationMinutes = parseInt(formData.duration);
        const endTime = this.calculateEndTime(time, durationMinutes);

        // Prepare session data following exactly the same structure as the existing modal
        const sessionData = {
          classeRoom: this.selectedClasse,
          trimester: this.selectedTrimester,
          day: formData.day,
          time: time,
          duration: parseInt(formData.duration),
          group: formData.group || null,
          week: formData.week || null,
          name: formData.name,
          teacher: formData.teacher,
          room: formData.room || null,
        };

        // Handle subject vs module logic exactly like the original
        const selectedItem = this.allSubjects.find(
          (s) => s._id === formData.subject
        );
        if (selectedItem && selectedItem.isModule) {
          // For modules, use moduleGeneral field
          sessionData.moduleGeneral = selectedItem._id;
          sessionData.subject = null;
        } else if (selectedItem && selectedItem.moduleId) {
          // For subjects from modules, use moduleGeneral field
          sessionData.moduleGeneral = selectedItem.moduleId;
          sessionData.subject = null;
        } else {
          // For regular subjects, use subject field
          sessionData.subject = formData.subject;
          sessionData.moduleGeneral = null;
        }

        // Validate timetable limits before submitting
        if (
          !this.validateTimetableLimits(
            sessionData.time,
            sessionData.duration,
            sessionData.day
          )
        ) {
          this.addSessionLoading = false;
          return;
        }

        // Make API call to create session exactly like the original
        const response = await apiClient.put("/schedules", {
          data: sessionData,
        });


        let sessionsArray = null;
        if (Array.isArray(response.data)) {
          sessionsArray = response.data;
        } else if (response.data.sessions && Array.isArray(response.data.sessions)) {
          sessionsArray = response.data.sessions;
        }

        if (sessionsArray && sessionsArray.length > 0) {
          const sessionsToAdd = sessionsArray.map((session) => {
            const displaySubject = session.subject
              ? session.subject
              : session.moduleGeneral;

            // Safely handle teacher data with fallbacks
            const teacherData = session.teacher || {};
            const employeeData = teacherData.employee || {};

            return {
              classeRoom: {
                _id: session.classeRoom?._id || session.classeRoom,
                name:
                  session.classeRoom?.name || this.$t("schedule.unknownClass"),
              },
              day: session.day,
              duration: session.duration,
              ends: session.ends,
              room: {
                name: session.room?.name || "",
                _id: session.room?._id || session.room || null,
              },
              subject: displaySubject
                ? { name: displaySubject.name, _id: displaySubject._id }
                : { name: "", _id: null },
              teacher: {
                _id: teacherData._id || teacherData,
                employee: {
                  firstName:
                    employeeData.firstName || this.$t("schedule.unknown"),
                  lastName:
                    employeeData.lastName || this.$t("schedule.teacher"),
                },
              },
              time: session.time,
              _id: session._id,
              name: session.name,
              week: session.week || null,
              group: session.group || null,
              includedSubjects: session.includedSubjects,
            };
          });

          // Add all sessions to the data arrays
          this.data.push(...sessionsToAdd);
          this.dataAllClasses.push(...sessionsToAdd);

          // Show success message
          this.$message.success(this.$t("success.seanceAjout"));
        } else {
          // Fallback for single session (backward compatibility)
          const displaySubject = response.data.subject
            ? response.data.subject
            : response.data.moduleGeneral;

          // Safely handle teacher data with fallbacks
          const teacherData = response.data.teacher || {};
          const employeeData = teacherData.employee || {};

          let newData = {
            classeRoom: {
              _id: response.data.classeRoom?._id || response.data.classeRoom,
              name:
                response.data.classeRoom?.name ||
                this.$t("schedule.unknownClass"),
            },
            day: response.data.day,
            duration: response.data.duration,
            ends: response.data.ends,
            room: {
              name: response.data.room?.name || "",
              _id: response.data.room?._id || response.data.room || null,
            },
            subject: displaySubject
              ? { name: displaySubject.name, _id: displaySubject._id }
              : { name: "", _id: null },
            teacher: {
              _id: teacherData._id || teacherData,
              employee: {
                firstName:
                  employeeData.firstName || this.$t("schedule.unknown"),
                lastName: employeeData.lastName || this.$t("schedule.teacher"),
              },
            },
            time: response.data.time,
            _id: response.data._id,
            name: response.data.name,
            week: response.data.week || null,
            group: response.data.group || null,
            includedSubjects: response.data.includedSubjects,
          };

          this.data.push(newData);
          this.dataAllClasses.push(newData);
          this.$message.success(this.$t("success.seanceAjout"));
        }

        // Close modal and refresh calendar exactly like the original
        this.closeAddSessionModal();

        // Force calendar refresh with a small delay to ensure DOM updates
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshCalendar();
          }, 100);
        });
      } catch (error) {
        // Handle errors with improved conflict type detection
        if (error.response && error.response.status == 400) {
          const conflictType = error.response.data.conflictType;
          const conflictDescription = this.formatConflictSessionDescription(
            error.response.data
          );
          const details = error.response.data.details || {};
          const schedule = error.response.data.schedule || {};

          if (error.response.data.errorId == 1) {
            const errorMessage =
              conflictType === "future_pattern"
                ? this.$t("error.classConflictFuture", {
                    className:
                      details.className ||
                      schedule.classeRoom?.name ||
                      "Unknown Class",
                  })
                : this.$t("error.classConflictUpdate", {
                    className:
                      details.className ||
                      schedule.classeRoom?.name ||
                      "Unknown Class",
                  });

            this.$message.error(errorMessage);
            this.addSessionError = {
              message: errorMessage,
              description: conflictDescription,
              details: details,
            };
          }

          if (error.response.data.errorId == 2) {
            const errorMessage =
              conflictType === "teacher_future_pattern"
                ? this.$t("error.teacherConflictFuture", {
                    teacherName:
                      details.teacherName ||
                      (schedule.teacher && schedule.teacher.employee
                        ? `${schedule.teacher.employee.firstName} ${schedule.teacher.employee.lastName}`
                        : "Unknown Teacher"),
                  })
                : this.$t("error.teacherConflictUpdate", {
                    teacherName:
                      details.teacherName ||
                      (schedule.teacher && schedule.teacher.employee
                        ? `${schedule.teacher.employee.firstName} ${schedule.teacher.employee.lastName}`
                        : "Unknown Teacher"),
                  });

            this.$message.error(errorMessage);
            this.addSessionError = {
              message: errorMessage,
              description: conflictDescription,
              details: details,
            };
          }

          if (error.response.data.errorId == 3) {
            this.$message.error(this.$t("error.salleIndis"));
            this.addSessionError = {
              message: this.$t("error.salleIndis"),
              description: this.$t("error.sallePriseEntre", {
                room: schedule.room?.name || "-",
                name: schedule.classeRoom?.name || "-",
                start: schedule.time || "-",
                end: schedule.ends || "-",
              }),
            };
          }

          if (error.response.data.errorId == 4) {
            this.$message.error(this.$t("error.capacite"));
          }
        } else {
          // Handle other types of errors
          this.$message.error(
            this.$t("error.error") || this.$t("schedule.errorCreatingSession")
          );
        }
      } finally {
        this.addSessionLoading = false;
      }
    },
    calculateEndTime(startTime, duration) {
      const [hours, minutes] = startTime.split(":").map(Number);
      const startMinutes = hours * 60 + minutes;
      const endMinutes = startMinutes + duration;

      const endHours = Math.floor(endMinutes / 60);
      const endMins = endMinutes % 60;

      return `${endHours.toString().padStart(2, "0")}:${endMins
        .toString()
        .padStart(2, "0")}`;
    },
    updateAddSessionButton() {
      if (this.$refs.calendar && this.$refs.calendar.getApi()) {
        const calendarApi = this.$refs.calendar.getApi();

        // Update the button visibility by modifying the header toolbar
        const headerToolbar = this.selectedClasse
          ? {
              left: "prev,next today addSessionBtn",
              center: "title",
              right: "timeGridWeek,timeGridDay,dayGridMonth",
            }
          : {
              left: "prev,next today",
              center: "title",
              right: "timeGridWeek,timeGridDay,dayGridMonth",
            };

        calendarApi.setOption("headerToolbar", headerToolbar);
      }
    },
    async loadFilteredTeachersAndRooms() {
      if (!this.selectedClasse) return;

      try {
        // Get current form values for day and time
        const formValues = this.addSessionForm.getFieldsValue();
        const day =
          formValues.day !== undefined ? formValues.day : this.selectedDay || 0;
        const time =
          formValues.time && typeof formValues.time.format === "function"
            ? formValues.time.format("HH:mm")
            : this.selectedTime || "08:00";

        // Load filtered teachers and rooms for the selected class and time
        const [teachersRes, roomsRes] = await Promise.all([
          apiClient.post("/teachers/filter", {
            query: { status: "active" },
            classroom: this.selectedClasse,
            day: day,
            time: time,
          }),
          apiClient.post("/rooms/filter", {
            query: {},
            classroom: this.selectedClasse,
            day: day,
            time: time,
          }),
        ]);

        // Initialize filtered data structure
        this.filtredTeachers = {
          disponible: teachersRes.data || [],
          indisponible: [],
        };
        this.filtredRooms = {
          disponible: roomsRes.data || [],
          indisponible: [],
        };
      } catch (error) {
        console.error("Error loading filtered teachers and rooms:", error);
        // Fallback to all teachers and rooms if filtering fails
        this.filtredTeachers = {
          disponible: this.teachers || [],
          indisponible: [],
        };
        this.filtredRooms = {
          disponible: this.rooms || [],
          indisponible: [],
        };
      }
    },
    handleAddSessionSubjectSelectChange(value) {
      // Find the selected item (module or subject)
      const selectedItem = this.allSubjects.find((item) => item._id === value);

      if (selectedItem) {
        // Use $nextTick to ensure the form is ready before setting the value
        this.$nextTick(() => {
          this.addSessionForm.setFieldsValue({ name: selectedItem.name });
        });

        if (selectedItem.isModule) {
          // If a module is selected, get all its subjects
          if (selectedItem.subjects && Array.isArray(selectedItem.subjects)) {
            this.includedSubjects = selectedItem.subjects.map((s) => s._id);
          } else {
            this.includedSubjects = [];
          }
        } else if (selectedItem.moduleId) {
          // If a subject from a module is selected, get all subjects from that module
          const originalModule = this.modules.find(
            (mod) => mod._id === selectedItem.moduleId
          );
          if (originalModule && originalModule.subjects) {
            this.includedSubjects = originalModule.subjects.map((s) => s._id);
          } else {
            this.includedSubjects = [];
          }
        } else {
          // If a direct subject is selected
          this.includedSubjects = [];
        }
      }
    },
    handleDayChange(value) {
      this.selectedDay = value;
      // Reload filtered teachers and rooms when day changes
      this.loadFilteredTeachersAndRooms();
    },
    handleTimeChange(time, timeString) {
      this.selectedTime = timeString;
      // Reload filtered teachers and rooms when time changes
      this.loadFilteredTeachersAndRooms();
    },
  },
  computed: {
    selectedTimeMoment() {
      return this.selectedTime ? moment(this.selectedTime, "HH:mm") : null;
    },
    disabledSessionHours() {
      return [0, 1, 2, 3, 4, 5, 6, 7, 19, 20, 21, 22, 23];
    },
    ...mapState(["settings", "user"]),
    countryIsTN() {
      const building = this.user.building.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0] || {};
      return building.countryCode == "TN";
    },
    currentLocale() {
      const localeMap = {
        'fr-FR': 'fr',
        'en-US': 'en',
        'ar-AR': 'ar-tn', // Use ar-tn for Arabic
        'sw-KE': 'sw', // Swahili support
      };
      return localeMap[this.$i18n.locale] || 'fr';
    },
    allSubjects() {
      // Combine modules and subjects into a single list
      const allItemsList = [];

      // Add modules first
      this.modules.forEach((module) => {
        if (module && module.status !== "inactive") {
          allItemsList.push({
            ...module,
            isModule: true,
          });
        }
      });

      // Add subjects from modules
      this.modules.forEach((module) => {
        if (module.subjects && Array.isArray(module.subjects)) {
          module.subjects.forEach((subject) => {
            if (subject && subject.status !== "inactive") {
              // Avoid duplicates
              if (!allItemsList.find((s) => s._id === subject._id)) {
                allItemsList.push({
                  ...subject,
                  moduleName: module.name,
                  moduleId: module._id,
                  isModule: false,
                });
              }
            }
          });
        }
      });

      // Add direct subjects
      this.subjects.forEach((subject) => {
        if (subject && subject.status !== "inactive") {
          // Avoid duplicates
          if (!allItemsList.find((s) => s._id === subject._id)) {
            allItemsList.push({
              ...subject,
              isModule: false,
            });
          }
        }
      });

      return allItemsList;
    },
    // Duration options in 1-minute slots (duration: 40 = 40 minutes)
    durationOptions() {
      return [
        { name: '30min', value: 30 },
        { name: '40min', value: 40 },
        { name: '45min', value: 45 },
        { name: '1h', value: 60 },
        { name: '1h15', value: 75 },
        { name: '1h30', value: 90 },
        { name: '1h45', value: 105 },
        { name: '2h', value: 120 },
        { name: '2h15', value: 135 },
        { name: '2h30', value: 150 },
      ];
    },
    classHours() {
      // Helper function to format duration using localized format string
      const formatDuration = (hours, minutes) => {
        return this.$t('emploi.durationFormat', { hours, minutes });
      };

      let hours = {
        total: 0,
        moy: 0,
        min: 0,
        max: 0,
        totalT: 0,
      };

      if (this.data && this.data.length > 0 && this.selectedWeekStart) {
        let hoursPerDay = [0, 0, 0, 0, 0, 0, 0]; // Sunday=0, Monday=1, ..., Saturday=6
        let teachers = [];
        let minutes = 0;

        const dataOfWeek = this.data.filter((schedule) => {
          const scheduleDate = new Date(schedule.day);

          // Use the selected week start date
          const weekStart = new Date(this.selectedWeekStart);
          // Ensure weekStart is at the beginning of the week (Monday)
          weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
          weekStart.setHours(0, 0, 0, 0);

          // Calculate week end (Sunday)
          const weekEnd = new Date(weekStart);
          weekEnd.setDate(weekStart.getDate() + 6);
          weekEnd.setHours(23, 59, 59, 999);

          // Check if schedule is in the selected week
          const isInSelectedWeek =
            scheduleDate >= weekStart && scheduleDate <= weekEnd;

          return isInSelectedWeek;
        });

        for (let i = 0; i < dataOfWeek.length; i++) {
          const schedule = dataOfWeek[i];

          // Extract day of week from the date (0=Sunday, 1=Monday, ..., 6=Saturday)
          let dayOfWeek = -1;
          if (schedule.day) {
            const date = new Date(schedule.day);
            if (!isNaN(date.getTime())) {
              dayOfWeek = date.getDay();
            }
          }

          // Process duration (duration is already in minutes - 1 slot = 1 minute)
          if (
            dayOfWeek >= 0 &&
            dayOfWeek < 7 &&
            typeof schedule.duration === "number" &&
            !isNaN(schedule.duration)
          ) {
            const durationMinutes = schedule.duration; // Already in minutes
            hoursPerDay[dayOfWeek] += durationMinutes;
            minutes += durationMinutes;
          }

          if (schedule.teacher && schedule.teacher.employee) {
            teachers.push(
              schedule.teacher.employee.firstName +
                " " +
                schedule.teacher.employee.lastName
            );
          }
        }

        if (minutes > 0) {
          const avgMinutes = minutes / 7;
          const avgHours = Math.floor(avgMinutes / 60);
          const avgMins = Math.floor(avgMinutes % 60);
          hours.moy = formatDuration(avgHours, avgMins);
        } else {
          hours.moy = formatDuration(0, 0);
        }

        if (minutes > 0) {
          const totalHours = Math.floor(minutes / 60);
          const totalMins = minutes % 60;
          hours.total = formatDuration(totalHours, totalMins);
        } else {
          hours.total = formatDuration(0, 0);
        }

        const maxMinutes = Math.max(...hoursPerDay);
        if (maxMinutes > 0 && !isNaN(maxMinutes)) {
          const maxHours = Math.floor(maxMinutes / 60);
          const maxMins = maxMinutes % 60;
          hours.max = formatDuration(maxHours, maxMins);
        } else {
          hours.max = formatDuration(0, 0);
        }
        hours.totalT = [...new Set(teachers)].length;
      } else {
        // Default values when no data
        hours.moy = formatDuration(0, 0);
        hours.total = formatDuration(0, 0);
        hours.max = formatDuration(0, 0);
        hours.totalT = 0;
      }

      return hours;
    },
    formattedCustomEndDate() {
      if (!this.customEndDate) return "";
      return moment(this.customEndDate).format("DD/MM/YYYY");
    },
    currentWeekType() {
      if (!this.settings.schoolarYears || !this.settings.activeSchoolarYear) {
        return "";
      }

      const schoolYear = this.settings.schoolarYears.find(
        (year) => year._id === this.settings.activeSchoolarYear
      );

      if (!schoolYear || !schoolYear.start) {
        return "";
      }

      // Get the Monday of the current week
      const dateToCheck = this.selectedWeekStart
        ? moment(this.selectedWeekStart).startOf("isoWeek")
        : moment().startOf("isoWeek");

      // Find the Monday of the week containing the school year start date
      const schoolYearStart = moment(schoolYear.start).startOf("isoWeek");

      // Calculate weeks between Mondays
      const weeksSinceStart = dateToCheck.diff(schoolYearStart, "weeks");

      return weeksSinceStart % 2 === 0 ? "A" : "B";
    },
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        headerToolbar: {
          left: "prev,next today addSessionBtn",
          center: "title",
          right: "timeGridWeek,timeGridDay,dayGridMonth",
        },
        buttonText: {
          today: this.$t("emploi.today"),
          month: this.$t("emploi.month"),
          week: this.$t("emploi.week"),
          day: this.$t("emploi.day"),
        },
        customButtons: {
          addSessionBtn: {
            text: "+",
            click: () => {
              if (!this.selectedClasse) {
                this.$message.error(this.$t("error.selectClasse"));
                return;
              }
              this.showAddSessionModal();
            },
            hint: this.$t("emploi.addSession"),
          },
        },
        initialView: "timeGridWeek",
        locale: this.currentLocale,
        locales: allLocales,
        firstDay: 1,
        allDaySlot: false,
        slotMinTime: "08:00:00",
        slotMaxTime: "18:00:00",
        slotDuration: "00:15:00",
        snapDuration: "00:15:00",
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventOverlap: true,
        events: (info, success) => this.getCalendarEvents(info, success),
        dateClick: (info) => this.fcDateClick(info),
        select: (info) => this.fcRangeSelect(info),
        eventClick: (info) => this.fcEventClick(info),
        eventDrop: (info) => this.fcEventDrop(info),
        eventResize: (info) => this.fcEventResize(info),
        datesSet: (info) => this.fcDatesSet(info),
      };
    },
  },
  watch: {
    selectedWeekStart: {
      handler(newVal, oldVal) {
        // Force reactivity when selectedWeekStart changes
        if (newVal && newVal !== oldVal) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
    },
    '$i18n.locale'(newLocale) {
      // Use ar-tn instead of ar for Arabic locale
      const calendarLocale = newLocale === 'ar-AR' ? 'ar-tn' :
                            newLocale === 'sw-KE' ? 'sw' :
                            newLocale === 'fr-FR' ? 'fr' :
                            newLocale === 'en-US' ? 'en' : 'fr';

      // Update the calendar locale if the calendar is already mounted
      if (this.$refs.calendar) {
        this.$refs.calendar.getApi().setOption('locale', calendarLocale);
      }
    },
    selectedClasse: async function (value) {
      this.loading = true;
      this.calendarLoading = true;

      const data = await this.fetchScheduleData();

      if (data) {
        this.data = data.filter(
          (sched) => sched.classeRoom._id == this.selectedClasse
        );

        // Get hideTeacher value from first session's classroom data
        // Only update if we haven't just updated it (to avoid overriding user changes)
        if (
          this.data.length > 0 &&
          this.data[0].classeRoom &&
          !this.justUpdatedHideTeacher
        ) {
          this.selectedClassHideTeacher =
            this.data[0].classeRoom.hideTeacher || false;
        }
        // Reset the flag after processing
        this.justUpdatedHideTeacher = false;

        this.dataAllClasses = data;
        this.loading = false;
        this.refreshCalendar();
      } else {
        this.loading = false;
        this.calendarLoading = false;
      }
    },
  },
};
</script>
<style scoped>
/* Clean Session Drawer Styles - Platform Theme */
.session-drawer {
  font-family: "Mukta", sans-serif;
}

/* Session Info */
.session-info {
  margin-bottom: 16px;
}

/* Platform consistent colors */
::v-deep .text-primary {
  color: #4b7cf3 !important;
}

::v-deep .text-success {
  color: #41b883 !important;
}

::v-deep .text-secondary {
  color: #595c97 !important;
}

::v-deep .text-muted {
  color: #a1a1c2 !important;
}

/* Consistent select styling for all dropdowns */
::v-deep .ant-select {
  font-family: "Mukta", sans-serif;
}

::v-deep .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #4b7cf3;
}

::v-deep .ant-select-focused .ant-select-selector {
  border-color: #4b7cf3 !important;
  box-shadow: 0 0 0 2px rgba(75, 124, 243, 0.2) !important;
}

/* Select option styling */
::v-deep .ant-select-item-option-selected {
  background-color: #f2f4f8;
  color: #595c97;
}

::v-deep .ant-select-item-option-active {
  background-color: #4b7cf3;
  color: #fff;
}

/* Tag styling within options */
::v-deep .ant-select-item .ant-tag {
  margin-left: 4px;
  font-size: 10px;
  line-height: 16px;
  height: 16px;
  padding: 0 4px;
}

/* Standard form spacing */
::v-deep .ant-form-item {
  margin-bottom: 16px;
}

/* Required field styling */
::v-deep .ant-form-item-required .ant-form-item-label > label::before {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

/* Required field label styling */
::v-deep .ant-form-item-required .ant-form-item-label > label {
  color: #262626;
  font-weight: 500;
}

/* Clean button styling - no gradients */
::v-deep .ant-btn-primary {
  background-color: #4b7cf3;
  border-color: #4b7cf3;
}

::v-deep .ant-btn-primary:hover {
  background-color: #42baf9;
  border-color: #42baf9;
}

/* Success button consistent with platform */
.success .ant-btn-danger {
  background: #41b883 !important;
  border-color: #41b883 !important;
}

/* Clean descriptions component */
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #f2f4f8;
  color: #595c97;
  font-weight: 500;
}

::v-deep .ant-descriptions-bordered .ant-descriptions-item-content {
  background-color: #fff;
  color: #595c97;
}

/* Simple Legend */
.schedule-legend {
  padding: 10px 16px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  text-align: center;
}

.legend-text {
  font-size: 14px;
  color: #495057;
  line-height: 1.4;
}

/* Calendar Header and Time Slot Styling - Bigger Fonts */
::v-deep .fc-col-header-cell {
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 12px 8px !important;
}

::v-deep .fc-daygrid-day-top {
  font-size: 15px !important;
  font-weight: 600 !important;
  padding: 8px 4px !important;
}

::v-deep .fc-timegrid-slot-label {
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 4px 8px !important;
}

::v-deep .fc-timegrid-axis {
  font-size: 13px !important;
  font-weight: 500 !important;
}

::v-deep .fc-timegrid-slot {
  font-size: 13px !important;
}

/* Enhanced Calendar Event Styling */
::v-deep .fc-event {
  font-size: 13px !important;
  line-height: 1.4 !important;
  border-radius: 6px !important;
  padding: 6px 8px !important;
  border: 1px solid #dee2e6 !important;
  font-weight: 500 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  min-height: 24px !important;
}

/* Group Events - Subtle left border */
::v-deep .fc-event.group-event {
  border-left: 4px solid #6c757d !important;
  padding-left: 6px !important;
}

/* Biweekly Events - Dashed border */
::v-deep .fc-event.biweekly-event {
  border-left: 4px dashed #adb5bd !important;
  padding-left: 6px !important;
}

/* Combined Group + Biweekly Events - Special styling */
::v-deep .fc-event.group-event.biweekly-event {
  border-left: 4px dashed #6c757d !important;
  padding-left: 6px !important;
  background-color: #f1f3f5 !important;
}

/* Very short events (< 30min) - minimal text for readability */
::v-deep .fc-event.very-short-event {
  font-size: 10px !important;
  line-height: 1.1 !important;
  padding: 3px 4px !important;
  min-height: 18px !important;
}

::v-deep .fc-event.very-short-event .fc-event-time {
  font-size: 9px !important;
  margin-bottom: 1px !important;
}

::v-deep .fc-event.very-short-event .fc-event-title {
  line-height: 1.1 !important;
  font-size: 9px !important;
}

/* Short events (< 1h) - smaller text for readability in compact cells */
::v-deep .fc-event.short-event {
  font-size: 11px !important;
  line-height: 1.2 !important;
  padding: 4px 6px !important;
  min-height: 20px !important;
}

::v-deep .fc-event.short-event .fc-event-time {
  font-size: 10px !important;
  margin-bottom: 1px !important;
}

::v-deep .fc-event.overlapping-event .fc-event-title {
  font-size: 9px !important;
  line-height: 1.1 !important;
  font-weight: normal !important;
}

/* Short events title styling - smaller font for better fit */
::v-deep .fc-event.short-event .fc-event-title {
  line-height: 1.2 !important;
}

/* Long events (>= 2h) - larger text for better readability */
::v-deep .fc-event.long-event {
  font-size: 14px !important;
  line-height: 1.4 !important;
  padding: 8px 10px !important;
  min-height: 28px !important;
}

::v-deep .fc-event.long-event .fc-event-time {
  font-size: 12px !important;
  margin-bottom: 3px !important;
}

::v-deep .fc-event.long-event .fc-event-title {
  line-height: 1.4 !important;
  font-size: 13px !important;
}

/* Canceled Events - Special styling */
::v-deep .fc-event.canceled-event {
  opacity: 0.8 !important;
  text-decoration: line-through !important;
  position: relative !important;
}

::v-deep .fc-event.canceled-event::before {
  content: "❌" !important;
  position: absolute !important;
  top: 2px !important;
  right: 2px !important;
  font-size: 12px !important;
  z-index: 10 !important;
}

::v-deep .fc-event.canceled-event .fc-event-title {
  font-style: italic !important;
  opacity: 0.9 !important;
}

/* Event title with multiline support */
::v-deep .fc-event-title {
  font-weight: inherit !important;
  white-space: pre-line !important;
  line-height: 1.3 !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

/* Event time styling */
::v-deep .fc-event-time {
  font-weight: 600 !important;
  font-size: 11px !important;
  opacity: 0.9 !important;
  margin-bottom: 2px !important;
}

/* Responsive */
@media (max-width: 768px) {
  .session-info {
    margin-bottom: 12px;
  }

  ::v-deep .ant-form-item {
    margin-bottom: 12px;
  }

  .schedule-legend {
    padding: 8px 12px;
  }

  .legend-text {
    font-size: 12px;
  }

  /* Responsive calendar header and time slot fonts */
  ::v-deep .fc-col-header-cell {
    font-size: 14px !important;
    padding: 8px 4px !important;
  }

  ::v-deep .fc-daygrid-day-top {
    font-size: 13px !important;
    padding: 6px 2px !important;
  }

  ::v-deep .fc-timegrid-slot-label {
    font-size: 12px !important;
    padding: 2px 4px !important;
  }

  /* Responsive event styling */
  ::v-deep .fc-event {
    font-size: 11px !important;
    padding: 4px 6px !important;
    min-height: 20px !important;
  }

  ::v-deep .fc-event.very-short-event {
    font-size: 9px !important;
    padding: 2px 3px !important;
    min-height: 16px !important;
  }

  ::v-deep .fc-event.short-event {
    font-size: 10px !important;
    padding: 3px 4px !important;
    min-height: 18px !important;
  }

  ::v-deep .fc-event.long-event {
    font-size: 12px !important;
    padding: 6px 8px !important;
    min-height: 24px !important;
  }
}

/* Simple Calendar Picker Modal */
.calendar-picker-modal {
  padding: 0;
}

.calendar-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.calendar-header p {
  margin: 0;
  color: #7f8c8d;
  font-size: 14px;
}

.duration-options {
  margin-bottom: 20px;
}

.duration-radio {
  display: block;
  margin-bottom: 12px;
  padding: 8px 12px;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.duration-radio:hover {
  border-color: #4b7cf3;
  background-color: #f8f9ff;
}

.duration-radio.ant-radio-wrapper-checked {
  border-color: #4b7cf3;
  background-color: #f0f4ff;
}

.calendar-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #f0f0f0;
}

.selected-date-preview {
  margin-top: 16px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 8px;
  border: 1px solid #e6f0ff;
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #667eea;
}

.delete-action-btn {
  margin-left: 8px;
  margin-top: 8px;
}

.selected-date-preview .anticon {
  margin-right: 8px;
  font-size: 16px;
}
</style>
